/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import Layout from 'components/Layout';
import { ButtonContent, RefreshButon, ModalityRowContainer, ModalityRowTitle, ModalityBottomSeparatorLine } from './styles';
import { FitinsurAPI, MessageCenter, CacheManager } from 'utils';
import MasksHelper from 'utils/src/masks';
import { GlobalAuthContext } from 'store/context';
import { cloneDeep, isEmpty } from 'lodash';
import * as yup from 'yup';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import {
    FormSectionGlobal as FormSection,
    FormContainer,
    GroupFormContainer,
    Button,
    ButtonContainer,
    LostCancelButton,
    HasPermission,
    NotesModal,
    ModalConfirmation,
    Icon,
    Label,
    DialogComponent
} from '@fitinsur/components'
import {
    LoaderContext
} from '@fitinsur/contexts'
import { useGetQuestionnairesByIdProduct } from 'services/QuestionnairesService';
import { useVerifyRiskAcceptance } from 'services/RiskAcceptanceService';
import { useGetCommercialPlansByIdOperationSync } from 'services/CommercialPlansService';
import { useCalculateSync } from 'services/PremiumCalculationService';

import {
    useGetOperationAsync,
    useUpdateOperationSync,
    useResetOperationState,
    useCheckBorrowerHasCreditAnalysis,
    useCheckMaxOperationAmount
} from '@fitinsur/services/OperationService';
import {
    useSavePersonRelationships
} from '@fitinsur/services/PersonRelationshipsService';
import {
    useGetQuestionnaireAnswer,
    useGetQuestionnaireAnswerAsync,
    useSaveAndExpiryQuestionnaireAnswer,
    useGetPetCadinStatusAsync,
    useGetSerasaStatusAsync,
    useGetSerasaStatusPartnerAsync,
    useGetDefaultingStatusAsync
} from '@fitinsur/services/QuestionnaireAnswerService';
import { useGetPersonRole } from 'services/PersonRoleService';
import Colors from "constants/Colors";
import {
    useGetDocumentsParams,
    useGetDocumentsAsync
} from '@fitinsur/services/DocumentsService';
import { useGenerateCCGASync, useSendCCGASync } from 'services/QuoteService';
import { useCreateCreditAnalysis, useUpdateCreditAnalysis } from 'services/CreditAnalysis';
import { useGetLimitConsumption } from '@fitinsur/services/CreditLimitService';
import { useRequestSompoUpdateBorrower } from 'services/IssueService';
import {
    useGetBorrowerLimit,
    useGetShareCapitalInfoByLegalPersonId,
    useSaveEconomicGroup,
    useUpdateEconomicGroup,
    useGetBorrowersInformationByLegalPersonIds,
    useGetEconomicGroupSectionHierarchy
} from '@fitinsur/services/EconomicGroupService';
import {
    useGetQuery
} from '@fitinsur/services/QuestionnairesService';
import {
    generalHandler,
    borrowerHandler,
    borrowerSecHandler,
    partnerHandler,
    shareCapitalHandler,
    creditAnalysisInfoHandler,
    limitsHandler,
    modalityHandler,
    economicGroupHandler,
    creditOpinionHandler,
    paymentMethodHandler,
    attachmentsHandler
} from './sectionHandlers/index';
import { EconomicGroupStatement } from 'components/index';
import { handleQuestionChange } from '../ccg-edit/handleQuestionChange';

export default function EditCreateAnalysis({ permissions, match, ...props }) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const [forceLoading, setForceLoading] = useState(false);
    const [forceLoadingInit, setForceLoadingInit] = useState(false);
    const [partners, setPartners] = useState([]);
    const [shareCapital, setShareCapital] = useState([]);
    const [limits, setLimits] = useState([]);
    const [modalities, setModalities] = useState([]);
    const [CNAESecondary, setCNAESecondary] = useState([]);
    const [economicGroup, setEconomicGroup] = useState([]);
    const [isEconomicGroup, setIsEconomicGroup] = useState(null);
    const [economicGroupToDelete, setEconomicGroupToDelete] = useState([]);
    const [initialEconomicGroup, setInitialEconomicGroup] = useState([]);
    const [isAwaitingAnalysis, setIsAwaitingAnalysis] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [questionnaire, setQuestionnaire] = useState([]);
    const [operation, setOperation] = useState(null);
    const [idOperation, setIdOperation] = useState(match.params?.idOperation || null);
    const [notesModal, setNotesModal] = useState(false);
    const [product, setProduct] = useState({});
    const [isBound, setIsBound] = useState(false);
    const [isSaveAction, setIsSaveAction] = useState(false);
    const [periodicityText, setPeriodicityText] = useState('-');
    const [infoRequiredDocs, setInfoRequiredDocs] = useState('');
    const goToNextPage = useRef(false);
    const sendReanalysis = useRef(false);
    const questionnaireSent = useRef(false);
    const questionnaireLoaded = useRef(false);
    const getQuestionnaire = useRef(false);
    const getCreditAnalysis = useRef(false);
    const economicGroupTotals = useRef({
        availableLimit: 0,//Limite
        approvedLimitValue: 0,//Limite Aprovado
        currentExposureValue: 0,//Exposição Vigente
        draftedValue: 0,//Minutado
        economicGroupCapacityValue: 0//Capacidade Disponível
    });
    const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]);
    const [canUpdateBorrowerSRO, setCanUpdateBorrowerSRO] = useState(false);
    const [borrowerConsumption, setBorrowerConsumption] = useState(null);
    const idOperationCCGProvider = useRef(null);
    const [systemReferenceDate, setSystemReferenceDate] = useState(new Date());
    const [currentModality, setCurrentModality] = useState(null);
    const [cnaeClassificationData, setCnaeClassificationData] = useState([]);
    const [scoreInformationData, setScoreInformationData] = useState([]);
    const [modalitiesFeesData, setModalitiesFeesData] = useState([]);
    const [maxRangeToModalityFee, setMaxRangeToModalityFee] = useState(null);
    const [creditLimits, setCreditLimits] = useState([]);
    const [dialog, setDialog] = useState({
        show: false,
        title: '',
        questions: []
    });
    const authContext = useContext(GlobalAuthContext);
    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    const formikRef = useRef();
    const sharedCCG = useRef(false);
    const generateCcg = useRef();
    const location = useLocation();
    const handleBack = () => history.goBack();
    const isClient = authContext.enumProfile === 1 ? true : false;
    const [messageInternal, setMessageInternal] = useState();
    const [messageExternal, setMessageExternal] = useState();
    const [warnings, setWarnings] = useState([]);
    const [brokerIdSelected, setBrokerIdSelected] = useState(null);
    const [modalConfirmation, setModalConfirmation] = useState({
        show: false,
        text: '',
        textButtonConfirm: '',
        textButtonCancel: '',
        onConfirm: () => { },
        onCancel: () => { }
    });
    const [initialOInfoCCGProvider, setInitialInfoCCGProvider] = useState({
        1726: '',
        1727: '',
        1728: '',
        borrowerPersonId: '',
        borrowerLegalId: ''
    });
    const [modalEconomicGroup, setModalEconomicGroup] = useState(false);
    const [documentCCG, setDocumentCCG] = useState(null);
    const [brokerList, setBrokerList] = useState([]);
    const [currentLimit, setCurrenLimit] = useState(null);
    const [outOfRangeError, setOutOfRangeError] = useState(null);

    const cache = new CacheManager();
    const maskHelper = new MasksHelper();

    const SECTIONS = {
        BORROWER: { name: 'BORROWER', isMultiple: false, isRisk: false },
        BORROWER_SEC: { name: 'BORROWER_SEC', isMultiple: true, isRisk: false },
        PARTNER: { name: 'PARTNER', isMultiple: true, isRisk: false },
        SHARE_CAPITAL: { name: 'SHARE_CAPITAL', isMultiple: true, isRisk: false },
        CREDIT_ANALYSIS_INFO: { name: 'CREDIT_ANALYSIS_INFO', isMultiple: false, isRisk: false },
        LIMITS: { name: 'LIMITS', isMultiple: true, isRisk: false },
        MODALITY: { name: 'MODALITY', isMultiple: true, isRisk: false },
        ECONOMIC_GROUP: { name: 'ECONOMIC_GROUP', isMultiple: true, isRisk: false },
        CCG_DATA: { name: 'CCG_DATA', isMultiple: false, isRisk: false },
        FINALIZE_CREDIT_ANALYSIS: { name: 'FINALIZE_CREDIT_ANALYSIS', isMultiple: false, isRisk: false }
    };

    const disableButton = (operation) => {
        if (isClient && operation.idDomain !== 26) return true;
        if (isClient && operation?.idDomainStatus && operation?.idDomainStatus !== 1 && operation?.idDomainStatus !== 8) return true;
        return false
    }

    const queryStringToJSON = () => {
        var pairs = location.search.slice(1).split('&');

        var result = {};
        pairs.forEach(pair => {
            pair = pair.split('=');
            result[pair[0]] = decodeURIComponent(pair[1] || '');
        });

        return JSON.parse(JSON.stringify(result));
    }

    const { back } = queryStringToJSON();

    const {
        loading: useGenerateCCGLoading,
    } = useGenerateCCGASync(match?.params?.idOperation);

    const {
        loading: useCheckBorrowerHasCreditAnalysisLoading,
        request: useCheckBorrowerHasCreditAnalysisRequest,
    } = useCheckBorrowerHasCreditAnalysis();

    const {
        data: useGetDocumentsParamsData,
        loading: useGetDocumentsParamsLoading,
        status: useGetDocumentsParamsStatus,
        request: useGetDocumentsParamsRequest,
    } = useGetDocumentsParams();

    const {
        data: getQuestionnaireData,
        loading: getQuestionnaireLoading,
        status: getQuestionnaireStatus,
        request: getQuestionnaireRequest,
    } = useGetQuestionnairesByIdProduct(match.params.idProduct || idOperation);

    const {
        data: useGetQuestionnairesAnswersData,
        loading: useGetQuestionnairesAnswersLoading,
        status: useGetQuestionnairesAnswersStatus,
        request: useGetQuestionnairesAnswersRequest,
    } = useGetQuestionnaireAnswer(match.params.idOperation || idOperation);

    const {
        loading: useGetOperationLoading,
        request: useGetOperationRequest
    } = useGetOperationAsync(match.params.idOperation || idOperation);

    const {
        loading: useUpdateOperationLoading,
        request: useUpdateOperationRequest
    } = useUpdateOperationSync(idOperation);

    const {
        data: useVerifyRiskAcceptanceData,
        loading: useVerifyRiskAcceptanceLoading,
        status: useVerifyRiskAcceptanceStatus,
        request: useVerifyRiskAcceptanceRequest
    } = useVerifyRiskAcceptance(idOperation);

    const {
        loading: useUpdateEconomicGroupLoading,
        request: useUpdateEconomicGroupRequest
    } = useUpdateEconomicGroup(idOperation);

    const {
        loading: useSaveEconomicGroupLoading,
        request: useSaveEconomicGroupRequest
    } = useSaveEconomicGroup(idOperation);

    const {
        loading: useGetCommercialPlansByIdOperationLoading,
    } = useGetCommercialPlansByIdOperationSync(match.params.idOperation || idOperation);

    const {
        loading: useCalculateLoading,
    } = useCalculateSync(match.params.idOperation || idOperation);

    const {
        loading: useResetOperationStateLoading,
        request: useResetOperationStateRequest,
    } = useResetOperationState(idOperation);

    const {
        loading: useGetPersonRoleLoading,
    } = useGetPersonRole(idOperation);

    const {
        loading: useSavePersonRelationshipsLoading
    } = useSavePersonRelationships();

    const {
        request: useGetQuestionnaireAnswerAsyncRequest,
        loading: useGetQuestionnaireAnswerAsyncLoading,
    } = useGetQuestionnaireAnswerAsync(idOperationCCGProvider.current);

    const {
        request: useGetPetCadinStatusAsyncRequest,
        loading: useGetPetCadinStatusAsyncLoading,
    } = useGetPetCadinStatusAsync(idOperation);

    const {
        request: useGetSerasaStatusAsyncRequest,
        loading: useGetSerasaStatusAsyncLoading,
    } = useGetSerasaStatusAsync(idOperation);

    const {
        request: useGetSerasaStatusPartnerAsyncRequest,
        loading: useGetSerasaStatusPartnerAsyncLoading,
    } = useGetSerasaStatusPartnerAsync();

    const {
        request: useGetDefaultingStatusAsyncRequest,
        loading: useGetDefaultingStatusAsyncLoading,
    } = useGetDefaultingStatusAsync(idOperation);

    const {
        data: useGetLimitConsumptionData,
        loading: useGetLimitConsumptionLoading,
        status: useGetLimitConsumptionStatus,
        request: useGetLimitConsumptionRequest,
    } = useGetLimitConsumption(idOperation);

    const {
        loading: useSendCCGASyncLoading,
        request: useSendCCGASyncRequest
    } = useSendCCGASync(idOperation);

    const {
        loading: useRequestSompoUpdateBorrowerLoading,
        request: useRequestSompoUpdateBorrowerRequest
    } = useRequestSompoUpdateBorrower();

    const {
        loading: useGetEconomicGroupSectionHierarchyLoading,
        request: useGetEconomicGroupSectionHierarchyRequest
    } = useGetEconomicGroupSectionHierarchy(idOperation);

    const {
        loading: useGetShareCapitalInfoByLegalPersonIdLoading,
        request: useGetShareCapitalInfoByLegalPersonIdRequest
    } = useGetShareCapitalInfoByLegalPersonId();


    const {
        loading: useCreateCreditAnalysisLoading,
        status: useCreateCreditAnalysisStatus,
        data: useCreateCreditAnalysisData,
        request: useCreateCreditAnalysisRequest,
        error: useCreateCreditAnalysisError
    } = useCreateCreditAnalysis();

    const {
        loading: useUpdateCreditAnalysisLoading,
        status: useUpdateCreditAnalysisStatus,
        request: useUpdateCreditAnalysisRequest,
        error: useUpdateCreditAnalysisError
    } = useUpdateCreditAnalysis(match?.params?.idOperation);

    const {
        loading: useGetBorrowersInformationByLegalPersonIdsLoading,
        request: useGetBorrowersInformationByLegalPersonIdsRequest
    } = useGetBorrowersInformationByLegalPersonIds();

    const {
        loading: useGetDocumentsAsyncLoading,
        request: useGetDocumentsAsyncRequest
    } = useGetDocumentsAsync(idOperation);

    const {
        loading: useGetBorrowerLimitLoading,
        request: useGetBorrowerLimitRequest
    } = useGetBorrowerLimit(idOperation);

    const {
        request: useGetQueryRequest,
        loading: useGetQueryLoading,
    } = useGetQuery();

    const {
        loading: useCheckMaxOperationAmountLoading,
        request: useCheckMaxOperationAmountRequest,
    } = useCheckMaxOperationAmount(match?.params?.idOperation);

    const requestBrokerList = async () => {
        const { data } = await useGetQueryRequest({
            id: 'fitQueryPersonBroker',
            params: {
                id: "fitQueryPersonBroker",
                queryTail: true,
                personName: ''
            }
        });

        try {
            if (data.ret_code !== 200) return;

            const persons = data.ret_value.map(person => ({
                ...person,
                label: person.personName,
                value: person.id
            }));

            setBrokerList(persons)
        } catch (err) {
            console.log("err fitQueryPersonBroker", err)
        };
    };

    useEffect(() => {
        if (getQuestionnaire.current) return;
        if (isEmpty(permissions)) return;
        getQuestionnaire.current = true;

        if (idOperation) {
            useGetOperationRequest(null, { loadLastDocument: true, loadOperationPersonRoles: true }).then(async (response) => {
                await requestBrokerList();
                let operationData;
                const { data: { value: [documentCCG] } } = await useGetDocumentsAsyncRequest(null, { idDomain: 689 });
                setDocumentCCG(documentCCG);
                const statusCCGDocument = documentCCG?.idDomainStatus;
                if (response.status === 200) {
                    operationData = response.data?.value;
                    setOperation(operationData);
                    setIsAwaitingAnalysis(operationData?.idDomainStatus === 419)
                    setIsBound([5, 419, 6, 133, 158, 187, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(operationData?.idDomainStatus))
                }

                if (back) {
                    useGetQuestionnairesAnswersRequest(null, { idDomainStatus: 425 })
                } else {
                    useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operationData?.idDomainStatus === 418 ? operationData?.idDomainStatus : statusCCGDocument ?? operationData?.idDomainStatus })
                }
            });
            useGetLimitConsumptionRequest(null, { getAllFinanceBalances: true, creditOperationId: idOperation });
        } else {
            requestBrokerList().then(() => getQuestionnaireRequest(null, { idDomainStatus: 425 }));
        }

        useGetDocumentsParamsRequest(null, { idDomain: [694, 702, 706] })
    }, [permissions, useCreateCreditAnalysisData, useCreateCreditAnalysisStatus]);

    useEffect(() => {
        const processQuestionnaire = async () => {
            if (useCreateCreditAnalysisStatus === 200 || useUpdateCreditAnalysisStatus === 200) {

                let operationIdCreate;

                if (useCreateCreditAnalysisStatus === 200) {
                    operationIdCreate = useCreateCreditAnalysisData?.value?.idOperation;
                    setIdOperation(operationIdCreate)
                };

                if ((!operation?.idDomainStatus || operation?.idDomainStatus === 425) && !isSaveAction) {

                    let CADINSuccess = false;
                    let CADINAttempts = 0;

                    mc.success("Consultando CADIN.");

                    async function CADINStatus() {
                        await useGetPetCadinStatusAsyncRequest({ idOperation: idOperation ?? operationIdCreate, operationType: "CADIN" })
                            .then(res => {
                                console.log(res)
                                if (res.status === 200 || res.status === 201) {
                                    CADINSuccess = true;
                                }
                            })
                            .catch(error => console.log(error));

                        if (!CADINSuccess && CADINAttempts < 3) {
                            CADINAttempts++;
                            await CADINStatus();
                        }
                    }

                    await CADINStatus();

                    if (!CADINSuccess) {
                        mc.error("Erro na requisição do sistema externo. Não foi possível consultar o CADIN. Tente novamente.");
                        await useUpdateOperationRequest({ idDomainStatus: 425 })

                        if (!operation?.idDomainStatus) {
                            return history.push('/credit-analysis/list');
                        }
                        return
                    }

                    let SERASASuccess = false;
                    let SERASAAttempts = 0;

                    mc.success("Consultando SERASA.");

                    async function SERASAtatus() {
                        await useGetSerasaStatusAsyncRequest({ idOperation: idOperation ?? operationIdCreate })
                            .then(res => {
                                console.log(res)
                                if (res.status === 200 || res.status === 201) {
                                    SERASASuccess = true;
                                }
                            })
                            .catch(error => console.log(error));

                        if (!SERASASuccess && SERASAAttempts < 3) {
                            SERASAAttempts++;
                            await SERASAtatus();
                        }
                    }

                    await SERASAtatus();

                    if (!SERASASuccess) {
                        mc.error("Erro na requisição do sistema externo. Não foi possível consultar o SERASA. Tente novamente.");
                        await useUpdateOperationRequest({ idDomainStatus: 425 })

                        if (!operation?.idDomainStatus) {
                            return history.push('/credit-analysis/list');
                        }
                        return
                    }

                    let defaultingSuccess = false;
                    let defaultingAttempts = 0;

                    mc.success("Consultando Inadimplência.");

                    async function defaultingStatus() {
                        await useGetDefaultingStatusAsyncRequest({ idOperation: idOperation ?? operationIdCreate })
                            .then(res => {
                                console.log(res)
                                if (res.status === 200 || res.status === 201) {
                                    defaultingSuccess = true;
                                }
                            })
                            .catch(error => console.log(error));

                        if (!defaultingSuccess && defaultingAttempts < 3) {
                            defaultingAttempts++;
                            await defaultingStatus();
                        }
                    }

                    await defaultingStatus();

                    if (!defaultingSuccess) {
                        mc.error("Erro na requisição do sistema externo. Não foi possível consultar as informações de inadimplência. Tente novamente.");
                        await useUpdateOperationRequest({ idDomainStatus: 425 })

                        if (!operation?.idDomainStatus) {
                            return history.push('/credit-analysis/list');
                        }
                        return
                    }
                }

                getCreditAnalysis.current = true;
            }

            const creditAnalysisError = useCreateCreditAnalysisStatus === 400 ?
                useCreateCreditAnalysisError :
                useUpdateCreditAnalysisStatus === 400 ? useUpdateCreditAnalysisError : null;

            if (creditAnalysisError) {
                creditAnalysisError.errors?.map(error => {
                    if (error.message) mc.error(error.message)
                })
            }
        }

        processQuestionnaire();
    }, [useCreateCreditAnalysisStatus, useUpdateCreditAnalysisStatus]);

    useMemo(() => {
        if (getCreditAnalysis.current) {
            getCreditAnalysis.current = false;
            useGetQuestionnairesAnswersRequest(null, { idDomainStatus: operation?.idDomainStatus || 425 });
            useVerifyRiskAcceptanceRequest(null, { draft: true });
        }
    }, [getCreditAnalysis.current])

    useEffect(() => {
        const save = async () => {
            if (useVerifyRiskAcceptanceStatus === 200) {
                const finalizeCreditAnalysis = questionnaire.find(
                    qst => qst.idQuestion === 2196
                )?.idAnswerOption === 7807;

                if (!sendReanalysis.current) {
                    if (canUpdateBorrowerSRO && [422, 424, 427].includes(operation?.document?.idDomainStatus)) {
                        mc.success(`Atualizando informações do tomador`);
                        let borrowerUpdated = false;

                        await useRequestSompoUpdateBorrowerRequest({ idOperation }).then((resp) => {
                            mc.success(`Informações do tomador atualizadas com sucesso`);
                            console.log("Borrower SRO updated");
                            borrowerUpdated = true;
                        }).catch((e) => {
                            console.log("Error updating Borrower SRO", e);
                            return mc.error(`Erro na requisição do sistema externo. Não foi possível atualizar informações do tomador. Tente novamente.`);
                        });

                        if (!borrowerUpdated) return;
                    }

                    const mainEconomicGroup = economicGroup.map((group) => {
                        return {
                            ...group,
                            economicGroupRelationships: group.economicGroupRelationships.filter(({ idOperation }) => !!idOperation)
                        }
                    }).find(
                        ({ contextHierarchyChildren }) => contextHierarchyChildren === true
                    )?.economicGroupRelationships ?? [];

                    const newParentEconomicGroup = economicGroup.find(
                        ({ contextHierarchyParent }) => contextHierarchyParent === true
                    )?.economicGroupRelationships.filter(({ isNew }) => isNew === true) ?? [];

                    (!operation?.idDomainStatus || operation?.idDomainStatus === 425)
                        ? await useSaveEconomicGroupRequest().then((data) => {
                            console.log("Grupos Economicos criados/editados com sucesso");
                        }).catch(async (e) => {
                            console.error(e);
                            await useUpdateOperationRequest({ idDomainStatus: 425 });
                        })
                        : await useUpdateEconomicGroupRequest({ economicGroup: [...mainEconomicGroup, ...newParentEconomicGroup], economicGroupToDelete }).then(({ data: { value } }) => {
                            console.log("useUpdateEconomicGroupRequest", value);
                            sendReanalysis.current = value?.operationStatusUpdated === 418;
                        })
                }

                // alterar condicional para execute esse passo apenas se o status da operação não seja 425,
                // Old: if (operation?.operationMetadata?.envelopeExternalId) {
                if (operation?.idDomainStatus && operation?.idDomainStatus !== 425) {
                    await useSendCCGASyncRequest();
                };

                if (sendReanalysis.current) {
                    mc.success(`Análise de crédito ${idOperation} enviada para reanálise`);
                    window.location.reload();

                    return;
                }

                if (!goToNextPage.current && !generateCcg.current) {
                    match.params.idOperation
                        ? mc.success(`Análise de crédito ${idOperation} atualizada com sucesso`)
                        : mc.success(`Análise de crédito ${idOperation} criada com sucesso`);
                    return history.push('/credit-analysis/list');
                }

                const { riskDescription, riskQuestions } = useVerifyRiskAcceptanceData?.value;
                const cadinSituation = riskQuestions.find(q => q.idQuestion === 1663).idAnswerOption === 7265;
                //const pepSituation = riskQuestions.find(q => q.idQuestion === 1664).idAnswerOption === 7267;
                let message;
                let messageIncidentsOccurredOrLossExpectation = false;

                questionnaire.map(qst => {
                    if ([1667, 1668].includes(qst.idQuestion)) {
                        if ([7273, 7275].includes(qst.idAnswerOption)) {
                            messageIncidentsOccurredOrLossExpectation = true
                        }
                    }
                })

                if (messageIncidentsOccurredOrLossExpectation) {
                    mc.error("Atenção! Esse tomador possuí indicação de Expectativa de Sinistro ou Sinistro Indenizado. Verificar se a situação foi regularizada.");
                    await new Promise(resolve => setTimeout(() => resolve(), 2500))
                }

                if (riskDescription === 'Declinar' || (cadinSituation /*|| pepSituation*/)) {
                    if (operation?.idDomainStatus !== 439 && operation?.idDomainStatus !== 418 && !operation?.operationMetadata?.envelopeExternalId) {
                        useUpdateOperationRequest({ idDomainStatus: 419 }).then(() => {
                            if (authContext.login_response.ret_value.idPersonRoot == authContext.login_response.ret_value.applicationPersonRoot) {
                                message = messageInternal;
                            } else {
                                message = messageExternal;
                            }
                            mc.error(message);
                            return history.push('/credit-analysis/list');
                        });
                        return
                    }
                }

                if (riskDescription === 'Analisar' && (!operation || operation?.idDomainStatus !== 439)) {
                    let idDomainStatus = (generateCcg.current && finalizeCreditAnalysis) ? 439 :
                        (!generateCcg.current && !finalizeCreditAnalysis && operation?.idDomainStatus === 418) ? 418 : 416;

                    if (finalizeCreditAnalysis && operation?.idDomainStatus !== 439) idDomainStatus = 439;

                    useUpdateOperationRequest({
                        idDomainStatus
                    }).then(() => {
                        if (generateCcg.current) {
                            history.push(`/credit-analysis/ccg-edit/${match.params.idProduct}/${match.params.idOperation}`);
                            return;
                        } else if (!goToNextPage.current) {
                            match.params.idOperation ? mc.success(`Análise de crédito ${idOperation} atualizada com sucesso`) : mc.success(`Análise de crédito ${idOperation} criada com sucesso`);
                            return history.push('/credit-analysis/list');
                        } else {
                            if (permissions.FORMALIZE_CREDIT_ANALYSIS || permissions.ANALYZE_CREDIT_ANALYSIS_SAVE) {
                                history.push(`/credit-analysis/edit/${match.params.idProduct}/${idOperation}`)
                                window.location.reload();
                                return;
                            } else {
                                mc.success(`Análise de crédito ${idOperation} enviada para análise`);
                                history.push('/credit-analysis/list');
                                return;
                            }
                        }
                    });

                    return;
                } else {
                    if (finalizeCreditAnalysis === true) {
                        if (operation?.idDomainStatus !== 439) {
                            await useUpdateOperationRequest({ idDomainStatus: 439 });
                        }
                    } else {
                        if (![425, 439].includes(operation?.idDomainStatus)) {
                            await useUpdateOperationRequest({ idDomainStatus: operation?.idDomainStatus });
                        }
                    }
                }

                if (generateCcg.current) {
                    useUpdateOperationRequest({ idDomainStatus: 439 }).then(() => {
                        history.push(`/credit-analysis/ccg-edit/${match.params.idProduct}/${match.params.idOperation}`);
                        return;
                    });
                } else if (!goToNextPage.current) {
                    match.params.idOperation
                        ? mc.success(`Análise de crédito ${idOperation} atualizada com sucesso`)
                        : mc.success(`Análise de crédito ${idOperation} criada com sucesso`);
                    return history.push('/credit-analysis/list');
                } else {
                    history.push(`/credit-analysis/edit/${match.params.idProduct}/${idOperation}`)
                    window.location.reload();
                    return;
                }
            }
        }

        save();
    }, [useVerifyRiskAcceptanceStatus]);

    useEffect(() => {
        if (
            useGetDocumentsParamsStatus === 200 &&
            (useGetLimitConsumptionStatus === 200 || !match.params.idOperation) &&
            (getQuestionnaireStatus === 200 || useGetQuestionnairesAnswersStatus === 200)
        ) {
            const cnaeClassification = useGetDocumentsParamsData.value.find(doc => doc.idDomain === 694)?.documentMetadata;
            const scoreInformation = useGetDocumentsParamsData.value.find(doc => doc.idDomain === 702)?.documentMetadata;
            const modalitiesFees = useGetDocumentsParamsData.value.find(doc => doc.idDomain === 706)?.documentMetadata;

            setCnaeClassificationData(cnaeClassification || []);
            setScoreInformationData(scoreInformation || []);
            setModalitiesFeesData(modalitiesFees || []);
            setMaxRangeToModalityFee(modalitiesFees?.reduce((max, modality) => modality.rangeTo > max ? modality.rangeTo : max, 0) || null);

            if (useGetLimitConsumptionData) setCreditLimits(useGetLimitConsumptionData.value);
        }
    }, [
        useGetDocumentsParamsStatus,
        getQuestionnaireStatus,
        useGetQuestionnairesAnswersStatus,
        useGetLimitConsumptionStatus
    ]);

    useEffect(() => {
        if (!isEmpty(cnaeClassificationData) && !isEmpty(scoreInformationData) && !isEmpty(modalitiesFeesData) && (getQuestionnaireStatus === 200 || useGetQuestionnairesAnswersStatus === 200)) {
            const referenceDate = getQuestionnaireData?.timestampLocal || useGetQuestionnairesAnswersData?.timestampLocal;
            setSystemReferenceDate(referenceDate);
            handleQuestionnaire(useGetQuestionnairesAnswersData?.value || getQuestionnaireData?.value, referenceDate);
        }
    }, [scoreInformationData, cnaeClassificationData, modalitiesFeesData, getQuestionnaireStatus, useGetQuestionnairesAnswersStatus]);

    useEffect(() => {
        if (questionnaireLoaded.current) return;

        if (questionnaire?.length && modalities?.length && economicGroup?.length && limits?.length && partners?.length) {
            questionnaireLoaded.current = true;
            const borrowerLegalIdQuestion = questionnaire.find(question => question.idQuestion === 1634);
            const borrowerLegalPersonName = questionnaire.find(question => question.idQuestion === 1635);
            const limitQuestion = limits[0].find(question => question.idQuestion === 1680);
            if (limitQuestion.answer != null && limitQuestion.answer != "") return;
            if (borrowerLegalIdQuestion && borrowerLegalIdQuestion.answer && (!borrowerLegalPersonName?.answer)) {
                setForceLoadingInit(true);

                generalHandler.events.serproRequest({
                    searchValue: borrowerLegalIdQuestion.answer,
                    token: authContext.token,
                    idOperation: null
                }).then(data => {
                    setForceLoadingInit(true);
                    setTimeout(() => setForceLoadingInit(false), 10000)
                    borrowerHandler.events.handleRequestSerproCnpj({
                        question: borrowerLegalIdQuestion,
                        data,
                        operation,
                        questionnaire,
                        setQuestionnaire,
                        setFieldValue: formikRef.current?.setFieldValue,
                        partners,
                        setPartners,
                        CNAESecondary,
                        setCNAESecondary,
                        cnaeClassificationData,
                        limits,
                        modalitiesFeesData,
                        scoreInformationData,
                        modalities,
                        setModalities,
                        questionnaireAnswersToDelete,
                        setQuestionnaireAnswersToDelete,
                    })
                });
            }
        }
    }, [questionnaire, economicGroup, limits, partners]);

    useEffect(() => {
        updateIsLoadingStatus(
            getQuestionnaireLoading ||
            useGetQuestionnairesAnswersLoading ||
            useGetOperationLoading ||
            useUpdateOperationLoading ||
            useVerifyRiskAcceptanceLoading ||
            useGetCommercialPlansByIdOperationLoading ||
            useCalculateLoading ||
            useResetOperationStateLoading ||
            useGetDocumentsParamsLoading ||
            useGenerateCCGLoading ||
            useSavePersonRelationshipsLoading ||
            useGetPersonRoleLoading ||
            forceLoading ||
            forceLoadingInit ||
            useGetPetCadinStatusAsyncLoading ||
            useGetSerasaStatusAsyncLoading ||
            useGetSerasaStatusPartnerAsyncLoading ||
            useGetDefaultingStatusAsyncLoading ||
            useCheckBorrowerHasCreditAnalysisLoading ||
            useGetLimitConsumptionLoading ||
            useSendCCGASyncLoading ||
            useRequestSompoUpdateBorrowerLoading ||
            useGetShareCapitalInfoByLegalPersonIdLoading ||
            useUpdateEconomicGroupLoading ||
            useSaveEconomicGroupLoading ||
            useGetQuestionnaireAnswerAsyncLoading ||
            useGetBorrowersInformationByLegalPersonIdsLoading ||
            useGetDocumentsAsyncLoading ||
            useGetEconomicGroupSectionHierarchyLoading ||
            useGetBorrowerLimitLoading ||
            useGetQueryLoading ||
            useCheckMaxOperationAmountLoading ||
            useUpdateCreditAnalysisLoading ||
            useCreateCreditAnalysisLoading
        )
    }, [
        getQuestionnaireLoading,
        useGetQuestionnairesAnswersLoading,
        useGetOperationLoading,
        useUpdateOperationLoading,
        useVerifyRiskAcceptanceLoading,
        useGetCommercialPlansByIdOperationLoading,
        useCalculateLoading,
        useResetOperationStateLoading,
        useGetDocumentsParamsLoading,
        useGenerateCCGLoading,
        useSavePersonRelationshipsLoading,
        useGetPersonRoleLoading,
        forceLoading,
        forceLoadingInit,
        useGetPetCadinStatusAsyncLoading,
        useGetSerasaStatusAsyncLoading,
        useGetSerasaStatusPartnerAsyncLoading,
        useGetDefaultingStatusAsyncLoading,
        useCheckBorrowerHasCreditAnalysisLoading,
        useGetLimitConsumptionLoading,
        useSendCCGASyncLoading,
        useRequestSompoUpdateBorrowerLoading,
        useGetShareCapitalInfoByLegalPersonIdLoading,
        useUpdateEconomicGroupLoading,
        useSaveEconomicGroupLoading,
        useGetQuestionnaireAnswerAsyncLoading,
        useGetBorrowersInformationByLegalPersonIdsLoading,
        useGetDocumentsAsyncLoading,
        useGetEconomicGroupSectionHierarchyLoading,
        useGetBorrowerLimitLoading,
        useGetQueryLoading,
        useCheckMaxOperationAmountLoading,
        useUpdateCreditAnalysisLoading,
        useCreateCreditAnalysisLoading
    ]);

    const handleQuestionnaire = async (data, referenceDate) => {
        let questionnaire = [];
        questionnaire = [
            ...data.persons,
            ...data.operations,
            ...data.payments,
            ...data.risks
        ];

        const { person: borrowerPerson } = operation?.operationPersonRoles?.find(
            personRole => personRole.idDomain === 497
        ) || {};

        setInitialInfoCCGProvider({
            1726: questionnaire.find(qst => qst.idQuestion === 1726)?.idAnswerOption || '',
            1727: questionnaire.find(qst => qst.idQuestion === 1727)?.answer || '',
            1728: questionnaire.find(qst => qst.idQuestion === 1728)?.answer || '',
            borrowerPersonId: borrowerPerson?.idPerson,
            borrowerLegalId: borrowerPerson?.legalPersonId
        });

        // 0 - General initial adjustments
        questionnaire = generalHandler.events.handleInitialAdjustments({ questionnaire })

        questionnaire = modalityHandler.events.handleInitialAdjustments({ questionnaire })

        questionnaire = attachmentsHandler.events.handleInitialAdjustments({ questionnaire })

        // 1 - Borrower initial adjustments
        questionnaire = borrowerHandler.events.handleInitialAdjustments({
            questionnaire,
            setFieldValue: formikRef?.current?.setFieldValue,
            permissions,
            authContext,
            setBrokerIdSelected,
            operation,
            brokerList,
            cnaeClassificationData
        });

        // 3 - Credit Analysis Info initial adjustments
        questionnaire = await creditAnalysisInfoHandler.events.handleInitialAdjustments({
            questionnaire,
            scoreInformationData,
            handleGetInfoCCGProvider
        })

        questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

        // 5 - Limits initial adjustments
        const groupQtsLimits = generalHandler.events.groupMultipleFieldQuestions({
            mainIdQuestion: 1680,
            questionnaire,
            handleQuestionsInitialAdjustments: limitsHandler.events.handleInitialAdjustments
        });

        let currentLimitQst = null;
        if (groupQtsLimits.length && currentLimit == null) {
            const approvedLimitQst = groupQtsLimits[groupQtsLimits.length - 1].find(({ idQuestion }) => idQuestion === 1680);
            currentLimitQst = approvedLimitQst?.answer;
            setCurrenLimit(approvedLimitQst?.answer)
        }

        const groupQstEconomicGroup = generalHandler.events.groupMultipleFieldQuestions({ mainIdQuestion: 1695, questionnaire, handleQuestionsInitialAdjustments: null });

        if (creditLimits.length) {
            groupQtsLimits.map((group, index) => {
                const approvedLimitQst = group.find(qst => qst.idQuestion === 1680);

                if (!approvedLimitQst?.idQuestionnaireAnswers) return group;

                const financeBalance = creditLimits.find(
                    balance => !balance.idProductPlan &&
                        balance.balanceMetadata?.limitId === approvedLimitQst?.idQuestionnaireAnswers
                );

                if (!financeBalance) return group;

                if (index === groupQtsLimits.length - 1) {
                    groupQstEconomicGroup[0].map(qst => {
                        if (qst.idQuestion === 1697) {
                            qst.answer = String(financeBalance.limitConsumed);
                        } else if (qst.idQuestion === 1698) {
                            qst.answer = String(financeBalance.limitDrafted);
                        } else if (qst.idQuestion === 1699) {
                            qst.answer = String(financeBalance.availableLimit);
                        }

                        return qst;
                    });
                }

                return group.map(qst => {
                    if (qst.idQuestion === 1681) {
                        qst.answer = String(financeBalance.limitConsumed);
                    } else if (qst.idQuestion === 1682) {
                        qst.answer = String(financeBalance.limitDrafted);
                    } else if (qst.idQuestion === 1683) {
                        qst.answer = String(financeBalance.availableLimit);
                    } else if (qst.idQuestion === 1688) {
                        qst.answer = String(financeBalance.premiumIssued);
                    }

                    return qst;
                });
            });
        }

        let messageIncidentsOccurredOrLossExpectation = false;
        questionnaire.map(qst => {
            if ([1667].includes(qst.idQuestion)) {
                if ([7273].includes(qst.idAnswerOption)) {
                    messageIncidentsOccurredOrLossExpectation = true
                }
            }
        })

        groupQtsLimits.map((group) => {
            return group.map(qst => {
                if (qst.idQuestion === 1687) {
                    qst.disabled = qst.disabled || messageIncidentsOccurredOrLossExpectation

                    if (!qst.answer) {
                        const answerOption = qst.answerOptions.find(q => q.idAnswerOption === (operation.idDomainStatus === 419 ? 7411 : 7407));
                        qst.answer = answerOption?.dsAnswerOption;
                        qst.idAnswerOption = answerOption.idAnswerOption;
                    }
                }

                return qst;
            });
        })

        // 1.2 - CNAE Secondary initial adjustments
        setCNAESecondary(generalHandler.events.groupMultipleFieldQuestions({
            mainIdQuestion: 1650,
            questionnaire,
            handleQuestionsInitialAdjustments: borrowerSecHandler.events.handleInitialAdjustments
        }));

        // 1.3 - Partner initial adjustments
        setPartners(generalHandler.events.groupMultipleFieldQuestions({
            mainIdQuestion: 1654,
            questionnaire,
            handleQuestionsInitialAdjustments: partnerHandler.events.handleInitialAdjustments
        }));

        // 2 - Share Capital initial adjustments
        const sharedCapitalQsts = generalHandler.events.groupMultipleFieldQuestions({
            mainIdQuestion: 1825,
            questionnaire,
            handleQuestionsInitialAdjustments: shareCapitalHandler.events.handleInitialAdjustments
        });
        setShareCapital(sharedCapitalQsts);

        // 4 - Modality initial adjustments
        let groupQtsModality = generalHandler.events.groupMultipleFieldQuestions({
            mainIdQuestion: 1736,
            questionnaire,
            handleQuestionsInitialAdjustments: null
        })

        groupQtsModality = groupQtsModality.map(group => group.map(question => {
            if (question.idQuestion === 1690 && currentLimitQst) {
                question.fieldMask.max = currentLimitQst;
            }
            return question;
        }));

        setModalities(groupQtsModality);

        const economicGrpAnswer = questionnaire.find(qst => qst.idQuestion === 1830)?.idAnswerOption === 7415;
        setIsEconomicGroup(economicGrpAnswer);

        setLimits(groupQtsLimits);

        setQuestionnaire(questionnaire);

        let economicGroups = [];
        if (operation && operation.idDomainStatus != 425) {
            try {
                updateIsLoadingStatus(true)

                const { data: { value: economicGroupHierarchyData } } = await useGetEconomicGroupSectionHierarchyRequest();

                const { totals, hierarchy } = economicGroupHierarchyData || {};
                economicGroupTotals.current = totals;

                const { data: { value: borrowerLimit } } = await useGetBorrowerLimitRequest();

                if (borrowerLimit) {
                    setBorrowerConsumption(borrowerLimit);
                }

                // 6 - Economic Group initial adjustments
                economicGroups = economicGroupHandler.events.handleInitialAdjustments({
                    groupQuestions: groupQstEconomicGroup,
                    setEconomicGroup,
                    setInitialEconomicGroup,
                    economicGroupSectionHierarchy: hierarchy,
                    isEconomicGroup: economicGrpAnswer
                });

                updateIsLoadingStatus(false);
            } catch (error) {
                console.log("economicGroupSection", error);
            }
        }

        const questionLimit = groupQtsLimits[0]?.find(qst => qst.idQuestion === 1680);

        if (currentLimitQst && +currentLimitQst > maxRangeToModalityFee) setOutOfRangeError(true);

        const questionSituation = groupQtsLimits[0]?.find(qst => qst.idQuestion === 1687);

        if (questionLimit && (!questionSituation.idAnswerOption || [7286, 7285, 7407].includes(questionSituation.idAnswerOption))) {
            if (!questionLimit?.answer || questionLimit?.answer == "") {
                const questionPEFIN = questionnaire.find(qst => qst.idQuestion === 1672);
                const isProject = questionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336;
                const consumedLimitGroup = groupQtsLimits[0]?.find(qst => qst.idQuestion === 1832)?.idAnswerOption === 7419;

                if (![439].includes(operation.idDomainStatus)) {
                    if (isProject && consumedLimitGroup) {
                        limitsHandler.events.handleSPELimit({
                            globalQuestionnaire: questionnaire,
                            limits: groupQtsLimits,
                            setLimits,
                            shareCapital: sharedCapitalQsts,
                            setFieldValue: formikRef.current?.setFieldValue,
                            modalitiesFeesData,
                            scoreInformationData,
                            modalities: groupQtsModality,
                            setModalities,
                            setQuestionnaireAnswersToDelete,
                            questionnaireAnswersToDelete,
                            useGetBorrowersInformationByLegalPersonIdsRequest,
                            mc
                        });
                    } else if (questionPEFIN) {
                        creditAnalysisInfoHandler.events.handleQuestionBlur({
                            question: questionPEFIN,
                            value: questionPEFIN?.answer,
                            questionnaireUpdated: questionnaire,
                            setQuestionnaire,
                            setFieldValue: formikRef.current?.setFieldValue,
                            limits: groupQtsLimits,
                            modalities: groupQtsModality,
                            setModalities,
                            modalitiesFeesData,
                            scoreInformationData,
                            setQuestionnaireAnswersToDelete,
                            questionnaireAnswersToDelete,
                            questionAnswersSERASA: null,
                            globalQuestionnaire: questionnaire
                        })
                    }
                }
            }
        }

        return questionnaire;
    }

    const getQuoteQuestionnaire = async () => {
        fitinsur.setAuthToken(authContext.token);
        let response = await fitinsur.requestProductsList().then(v => v.json())
        if (response.ret_code != 200) return;
        let product = response.ret_value.find(v => +v.ID_PRODUCT === +match.params.idProduct);
        setProduct(product);
    }

    const validationCNPJGroup = (validationSchema) => {
        const seen = new Set();
        for (const groups of economicGroup) {
            for (const group of groups.economicGroupRelationships) {
                if (group.personRelationshipExpireDate) continue
                group?.questions
                    .filter(({ idQuestion }) => [1695].includes(idQuestion))
                    .forEach(({ answer, key }) => {
                        const answerJson = answer.length < 15 ? answer : JSON.parse(answer).value ?? answer;
                        seen.has(answerJson) ? validationSchema[key] = yup.string().test({
                            name: "answer-validation",
                            message: "CPFCNPJ",
                            test: (value) => !seen.has(value)
                        }) : seen.add(answerJson)
                    })
            }
        }
    }

    const buildValidation = (draft) => {

        const validationSchema = {};

        const questionnaire = handleSaveQuestionnaireAnswer(true);

        let allQuestions = [...questionnaire];

        const field1723Validation = allQuestions.find(item => item.idQuestion === 1723);

        if (field1723Validation &&
            field1723Validation.idAnswerOption !== 7336) {
            validationCNPJGroup(validationSchema);
        };

        for (const question of allQuestions) {
            if (question.childrenQuestions?.length) allQuestions = [...allQuestions, ...question.childrenQuestions]
        }

        const field1654Validation = allQuestions
            .filter(question => question.visibleQuestion && question.idQuestion === 1654)
            .map(question => question.answer)
            .sort((a, b) => a - b);
        const field1713Validation = allQuestions
            .filter(question => question.visibleQuestion && question.idQuestion === 1713)
            .map(question => question.answer)
            .sort((a, b) => a - b);
        const field1825Validation = allQuestions
            .filter(question => question.visibleQuestion && question.idQuestion === 1825)
            .map(question => question.answer)
            .sort((a, b) => a - b);

        for (const question of allQuestions) {
            if (draft && ![1634, 1776, 1637].includes(question.idQuestion)) continue;
            if ([614].includes(question?.idDomainQuestion)) continue;
            if (!question?.key || !(question.visibleQuestion)) continue;

            question?.childrenQuestions?.map(item => {
                if (item.visibleQuestion && item.fieldMask?.type == 'phone' && item.behaviorObject?.isRequired) {
                    validationSchema[item.key] = yup.string().test({
                        name: "answer-validation",
                        message: "Telefone inválido",
                        test: (value) => !!value && value.length >= 10
                    })
                } else if (item.visibleQuestion && item.behaviorObject?.fieldMask == 'email') {
                    if (item.answer) {
                        validationSchema[item.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
                    } else {
                        if (item.behaviorObject?.isRequired) {
                            validationSchema[item.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
                        } else {
                            validationSchema[item.key] = yup.string().notRequired().nullable();
                        }
                    }
                } else {
                    validationSchema[item.key] = item.visibleQuestion && item.behaviorObject?.isRequired
                        ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
                            return !!item.answer;
                        }) : yup.string().notRequired().nullable();
                }
            })

            if (question.visibleQuestion && question.behaviorObject?.isRequired && question.fieldMask?.type == 'phone') {
                validationSchema[question.key] = yup.string().test({
                    name: "answer-validation",
                    message: "Telefone inválido",
                    test: (value) => !!value && value.length >= 10
                })
            } else if (question.visibleQuestion && question.behaviorObject?.fieldMask == 'email') {
                if (question.answer) {
                    validationSchema[question.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
                } else {
                    if (question.behaviorObject?.isRequired) {
                        validationSchema[question.key] = yup.string().email("E-mail inválido").required("Campo obrigatório")
                    } else {
                        validationSchema[question.key] = yup.string().notRequired().nullable();
                    }
                }
            } else if (
                question.idQuestion === 1654 &&
                question.answer &&
                question.visibleQuestion &&
                question.behaviorObject?.isRequired &&
                field1654Validation.length > 1
            ) {
                validationSchema[question.key] = yup.string().test(
                    "answer-validation",
                    "CPFCNPJ",
                    () => {
                        const uniquefields = Array.from(new Set(field1654Validation)).sort((a, b) => a - b);
                        return uniquefields.length === field1654Validation.length && uniquefields.every((value, index) => value === field1654Validation[index] && value !== '');
                    }
                );
            } else if (
                question.idQuestion === 1713 &&
                question.answer &&
                question.visibleQuestion &&
                question.behaviorObject?.isRequired &&
                field1713Validation.length > 1
            ) {
                validationSchema[question.key] = yup.string().test(
                    "answer-validation",
                    "CPFCNPJ",
                    () => {
                        const uniquefields = Array.from(new Set(field1713Validation)).sort((a, b) => a - b);
                        return uniquefields.length === field1713Validation.length && uniquefields.every((value, index) => value === field1713Validation[index]);
                    }
                );
            } else if (
                question.idQuestion === 1825 &&
                question.answer &&
                question.visibleQuestion &&
                question.behaviorObject?.isRequired &&
                field1825Validation.length > 1
            ) {
                validationSchema[question.key] = yup.string().test(
                    "answer-validation",
                    "CPFCNPJ",
                    () => {
                        const uniquefields = Array.from(new Set(field1825Validation)).sort((a, b) => a - b);
                        return uniquefields.length === field1825Validation.length && uniquefields.every((value, index) => value === field1825Validation[index]);
                    }
                );
            } else {
                validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
                    ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
                        return !!question.answer;
                    }) : yup.string().notRequired().nullable();
            }
        }

        // Required Broker question for all cases
        const qstBroker = allQuestions.find(qst => qst.idQuestion === 1776);
        if (qstBroker) {
            validationSchema[qstBroker.key] = yup.string().test("answer-validation", "Campo obrigatório", function (value) {
                return !!qstBroker.answer;
            })
        }

        return yup.object().shape(validationSchema);
    }

    const handleValidationsSubmittedForm = async (draft) => {
        if (draft) return true;

        let validationResult = true;

        if (operation?.idOperation && operation?.idDomainStatus !== 425) {
            const isProjectQuestion = questionnaire.find(qst => qst.idQuestion === 1723);
            const consumedLimitGroup = limits[limits.length - 1].find(qst => qst.idQuestion === 1832);

            if (isProjectQuestion?.idAnswerOption === 7336 && consumedLimitGroup?.idAnswerOption === 7419) {
                validationResult = await limitsHandler.events.handleSPELimit({
                    globalQuestionnaire: questionnaire,
                    limits,
                    setLimits,
                    shareCapital,
                    setFieldValue: formikRef.current?.setFieldValue,
                    modalitiesFeesData,
                    scoreInformationData,
                    modalities,
                    setModalities,
                    setQuestionnaireAnswersToDelete,
                    questionnaireAnswersToDelete,
                    useGetBorrowersInformationByLegalPersonIdsRequest,
                    mc,
                    adhocToValidate: true
                });
            }
        }

        const hasShareCapital = generalHandler.events.sectionIsVisible({
            sectionName: "SHARE_CAPITAL",
            questionnaire: shareCapital && shareCapital[0] || [],
            permissions,
            currentModality,
            ignoreVisibilityByModality: true
        });
        const isProject = questionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336;

        if (operation?.idDomainStatus === 418) {
            let attachments = questionnaire?.find(qst => qst.idQuestion === 1706);

            if (!attachments || !Array.isArray(attachments.answer)) attachments = [];

            const typesRequiredDocuments = [7344, 7345];

            let attachmentQuestion = questionnaire.find((q) => q.idQuestion == 1706);

            let descriptionDocs = '';
            for (const type of typesRequiredDocuments) {
                const description = attachmentQuestion.answerOptions.find(opt => opt.idAnswerOption === type).dsAnswerOption;
                descriptionDocs += `${description + '\n'}`;
                if (!attachments.answer?.find(doc => +doc.documentType?.idAnswerOption === type)) {
                    if (validationResult) validationResult = false;
                    mc.error(`Foi identificado que o ${description} não foi incluído; Favor anexa-lo!`);
                }
            }

            setInfoRequiredDocs(descriptionDocs)
        }

        if (hasShareCapital && isProject) {
            const percentageParticipation = shareCapital.map(
                group => (group.find(qst => qst.idQuestion === 1828))
            );

            const totalPercentage = percentageParticipation.reduce((accumulator, currentValue) => {
                return accumulator + parseFloat(currentValue.answer || 0);
            }, 0);

            if (totalPercentage !== 100) {
                validationResult = false;
                for (const qst of percentageParticipation) {
                    formikRef.current?.setFieldError(
                        qst.key,
                        'Percentual de Participação deve totalizar 100%'
                    );
                }
                mc.error('O percentual de participação dos socios na COMPOSIÇÃO CAPITAL SOCIAL deve totalizar 100%');
            }

            const borrowerLegalPersonId = questionnaire.find(qst => qst.idQuestion === 1634);

            const projectLegalPersonIdInShareCapital = shareCapital.find(
                group => group.find(qst => qst.idQuestion === 1826)?.answer === borrowerLegalPersonId?.answer
            );

            if (projectLegalPersonIdInShareCapital) {
                validationResult = false;
                mc.error(`O CNPJ do tomador (${borrowerLegalPersonId}) não pode ser igual ao CNPJ de um dos sócios.`);
            }
        }

        return validationResult;
    }

    const onSave = async (values, idDomainStatus, draft, shoudGenerateCcg, setFieldError) => {
        const finalizeCreditAnalysis = questionnaire.find(
            qst => qst.idQuestion === 2196
        )?.idAnswerOption === 7807;

        if (idOperation && [416, 417, 418].includes(operation?.idDomainStatus) && !shoudGenerateCcg && finalizeCreditAnalysis) {
            const approvedLimitQst = limits[limits.length - 1].find(({ idQuestion }) => idQuestion === 1680);

            try {
                await useCheckMaxOperationAmountRequest(null, { operationValue: approvedLimitQst.answer });
            } catch (err) {
                if (err?.response?.data?.errors?.length) {
                    err?.response?.data?.errors.map(error => mc.error(error.message));
                    return;
                } else {
                    mc.error("Falha ao confirmar a operação, tente novamente!");
                    return;
                }
            }
        }

        generateCcg.current = shoudGenerateCcg;
        goToNextPage.current = !draft;
        sendReanalysis.current = idDomainStatus === 418;

        buildValidation(draft || sendReanalysis.current).validate(values, { abortEarly: false }).then(async () => {
            const validationResult = await handleValidationsSubmittedForm(draft || sendReanalysis.current);

            if (validationResult) handleSubmit({ idDomainStatus });
        }).catch((e) => {
            generalHandler.events.onValidationError(
                e,
                mc,
                formikRef,
                questionnaire,
                [
                    ...partners,
                    ...limits,
                    ...modalities,
                    ...CNAESecondary,
                    ...shareCapital,
                ],
                setFieldError
            )
        })
    }

    const handleSubmit = async ({ idDomainStatus }) => {
        if (questionnaireSent.current) return;

        const questionnaire = handleSaveQuestionnaireAnswer();

        if (
            idOperation &&
            ((operation?.idDomainStatus === 425 && idDomainStatus === 416) ||
                idDomainStatus === 418)
        ) {
            if (operation?.idDomainStatus === 419 && idDomainStatus === 418) {
                setQuestionnaire((questionnaire) =>
                    questionnaire.map((question) =>
                        question.idQuestion === 1687
                            ? { ...question, idAnswerOption: 7407 }
                            : question
                    )
                );
            }

        }

        if (!idOperation) {
            await useCreateCreditAnalysisRequest({
                idDomainStatus: idDomainStatus || 425,
                idProduct: parseInt(match.params.idProduct),
                questionnaire,
                questionnaireAnswersToDelete
            });
        } else {
            await useUpdateCreditAnalysisRequest({
                idDomainStatus: idDomainStatus ?? operation.idDomainStatus,
                idProduct: parseInt(match.params.idProduct),
                questionnaire,
                questionnaireAnswersToDelete
            });
        }
    }

    const handleSaveQuestionnaireAnswer = (onlyQuestions) => {
        let questionnaireAnswers = cloneDeep(questionnaire);
        for (const [key, section] of Object.entries(SECTIONS)) {
            if (section.isMultiple) {
                let multipleFields = []
                switch (section.name) {
                    case 'PARTNER':
                        multipleFields = cloneDeep(partners);
                        break;
                    case 'SHARE_CAPITAL':
                        multipleFields = cloneDeep(shareCapital);
                        break;
                    case 'LIMITS':
                        multipleFields = cloneDeep(limits);
                        break;
                    case 'MODALITY':
                        multipleFields = cloneDeep(modalities);
                        break;
                    case 'ECONOMIC_GROUP':
                        const multipleQuestions = economicGroup
                            .flatMap(group => group.economicGroupRelationships)
                            .map(relationship => relationship.questions);
                        multipleFields = cloneDeep(multipleQuestions);
                        break;
                    case 'BORROWER_SEC':
                        multipleFields = cloneDeep(CNAESecondary);
                        break;
                    default:
                        multipleFields = [];
                        break;
                }

                // QUEBRANDO O CODIGO
                multipleFields.map(group => {
                    if (group?.length) {
                        const rootQuestion = group.find(question => !question.idQuestionRoot);
                        const childrenQuestions = group.filter(question => question.idQuestionRoot);
                        rootQuestion.childrenQuestions = childrenQuestions;
                        if (!onlyQuestions) {
                            questionnaireAnswers = [...questionnaireAnswers, rootQuestion];
                        } else {
                            questionnaireAnswers = [...questionnaireAnswers, ...group];
                        }
                    }
                })
            }
        }

        let childrenQuestionIds = [];
        for (const question of questionnaireAnswers) {
            if (question) {
                if (
                    (
                        question.idDomainQuestion === 270 ||
                        question.idDomainQuestion === 271 ||
                        (question.idDomainQuestion === 44 && typeof question.answer === 'object')
                    ) && question.answer
                ) {
                    try {
                        question.answer = JSON.stringify(question.answer)
                    } catch (e) {
                    }
                }

                if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
                    if (question?.childrenQuestions?.length) {
                        const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
                        childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
                    }
                } else {
                    question.childrenQuestions = [];
                }

                if (
                    currentModality &&
                    question.productPlans?.length &&
                    !question.productPlans.includes(currentModality) &&
                    (question?.answer != null || question?.idAnswerOption)
                ) {
                    question.answer = null;
                    question.idAnswerOption = null;
                }
            }
        }

        questionnaireAnswers = questionnaireAnswers.filter(v =>
            !childrenQuestionIds.includes(v.idQuestion) && ![1726, 1727, 1728].includes(v.idQuestion)
        );

        if (onlyQuestions) return questionnaireAnswers;

        const situationLimit = questionnaireAnswers.find(qstRoot => {
            if (qstRoot.idQuestion == 1680) {
                const situationStatus = qstRoot.childrenQuestions.find(
                    qst => qst.idQuestion == 1687
                )?.idAnswerOption === 7407;
                return situationStatus;
            }
        });

        let finalizeCreditAnalysis = questionnaireAnswers.find(qst => qst.idQuestion === 2196)?.idAnswerOption === 7807;

        if (sendReanalysis.current && finalizeCreditAnalysis) {
            const finalizeCreditAnalysisQst = questionnaireAnswers.find(qst => qst.idQuestion === 2196)
            const answerOption = finalizeCreditAnalysisQst.answerOptions.find(
                opt => opt.idAnswerOption === 7806
            );
            finalizeCreditAnalysisQst.answer = answerOption?.dsAnswerOption || '';
            finalizeCreditAnalysisQst.idAnswerOption = answerOption?.idAnswerOption || null;
            finalizeCreditAnalysis = false;
        }

        if (generateCcg.current && !finalizeCreditAnalysis) {
            mc.error("Análise de Crédito não finalizada. É necessário que o campo Finalizar Análise de Crédito esteja marcado.");
            generateCcg.current = false;
        }

        if (finalizeCreditAnalysis && situationLimit) {
            situationLimit.childrenQuestions = situationLimit.childrenQuestions.map(qst => {
                if (qst.idQuestion === 1687) {
                    const answerOption = qst.answerOptions.find(
                        opt => opt.idAnswerOption === 7286
                    );
                    qst.answer = answerOption?.dsAnswerOption || '';
                    qst.idAnswerOption = answerOption?.idAnswerOption || null;
                }
                return qst;
            })
        }

        return questionnaireAnswers;
    }

    const handleReanalyze = async () => {
        handleModalCancel();
        await onSave(formikRef.current.values, 418, false, false, formikRef.current.setFieldError);
    };

    const handleModalCancel = () => {
        setModalConfirmation({
            show: false,
            text: '',
            textButtonConfirm: '',
            textButtonCancel: '',
            onConfirm: () => { },
            onCancel: () => { }
        });
    };

    const handleCurrentExposure = (limitExposure) => {
        const limitQuestion = limits[0].find(question => question.idQuestion === 1680);

        if (Number(limitExposure) > Number(limitQuestion.answer)) {
            setModalConfirmation({
                show: true,
                text: `A empresa que está sendo associada tem uma exposição vigente maior que o limite do grupo aprovado, deseja associar esta empresa ao grupo Econômico?`,
                textButtonConfirm: '',
                textButtonCancel: '',
                onConfirm: () => handleModalCancel(),
                onCancel: () => { setEconomicGroup(economicGroup.filter((v, i) => i !== economicGroup.length - 1)); handleModalCancel() },
            })
        }
    };

    function handleChoiceOfConsumptionLimit(
        economicGroupQuestions,
        setEconomicGroupQuestions,
        borrowerOperationId,
        setFieldValue
    ) {
        function handleChangeQstLimit(consumeGroupLimit) {
            setEconomicGroupQuestions(
                economicGroupQuestions.map(qst => {
                    if (qst.idQuestion === 1852) {//Limite do Grupo ?
                        //7464(No) 7465(Yes)
                        const answerOption = qst.answerOptions.find(
                            opt => opt.idAnswerOption === (consumeGroupLimit ? 7465 : 7464)
                        );

                        qst.answer = answerOption.dsAnswerOption;
                        qst.idAnswerOption = answerOption.idAnswerOption;

                        setFieldValue && setFieldValue(
                            qst.key,
                            {
                                dsAnswerOption: answerOption.dsAnswerOption,
                                idAnswerOption: answerOption.idAnswerOption
                            }
                        );
                    }
                    return qst;
                }),
                borrowerOperationId
            );

            handleChoiceOfWhichCCGToUse(
                economicGroupQuestions,
                setEconomicGroupQuestions,
                borrowerOperationId,
                setFieldValue
            );
        }

        setModalConfirmation({
            show: true,
            text: 'O Tomador irá consumir o limite do Grupo?',
            textButtonConfirm: 'Sim',
            textButtonCancel: 'Não',
            onConfirm: () => handleChangeQstLimit(true),
            onCancel: () => handleChangeQstLimit(false)
        });
    };

    function handleChoiceOfWhichCCGToUse(
        economicGroupQuestions,
        setEconomicGroupQuestions,
        borrowerOperationId,
        setFieldValue
    ) {
        function handleChangeQstCCG(usesProviderCCG) {
            setEconomicGroupQuestions(
                economicGroupQuestions.map(qst => {
                    if (qst.idQuestion === 1851) {//CCG
                        //7462(No) 7463(Yes)
                        const answerOption = qst.answerOptions.find(
                            opt => opt.idAnswerOption === (usesProviderCCG ? 7462 : 7463)
                        );

                        qst.answer = answerOption.dsAnswerOption;
                        qst.idAnswerOption = answerOption.idAnswerOption;

                        setFieldValue && setFieldValue(
                            qst.key,
                            {
                                dsAnswerOption: answerOption.dsAnswerOption,
                                idAnswerOption: answerOption.idAnswerOption
                            }
                        );
                    }
                    return qst;
                }),
                borrowerOperationId
            );

            handleModalCancel();
        }

        setModalConfirmation({
            show: true,
            text: 'Deseja utilizar o CCG do Grupo Econômico?',
            textButtonConfirm: 'Sim',
            textButtonCancel: 'Não',
            onConfirm: () => handleChangeQstCCG(true),
            onCancel: () => handleChangeQstCCG(false)
        });
    }

    async function handleGetInfoCCGProvider(idPerson, personLegalId) {
        if (!idPerson || !personLegalId) {
            if (!initialOInfoCCGProvider.borrowerLegalId || !initialOInfoCCGProvider.borrowerPersonId) {
                const { person: borrowerPerson } = operation?.operationPersonRoles?.find(
                    personRole => personRole.idDomain === 497
                ) || {};

                return {
                    ...initialOInfoCCGProvider,
                    borrowerPersonId: borrowerPerson?.idPerson,
                    borrowerLegalId: borrowerPerson?.legalPersonId
                };
            }

            return initialOInfoCCGProvider;
        };

        const idOperationCCGProvider = await useCheckBorrowerHasCreditAnalysisRequest(
            null,
            {
                idProduct: match.params.idProduct,
                borrowerLegalId: personLegalId,
                idQuestion: 1634
            }
        ).then(
            ({ data: { value } }) => value?.creditAnalysisOperationWithBroker?.idOperation
        );

        const questionnaireProvider = await useGetQuestionnaireAnswerAsyncRequest(
            null,
            { idQuestions: [1726, 1727, 1728] },
            null,
            `/v2/operation/${idOperationCCGProvider}/questionnaire-answer`
        ).then(({ data: { value } }) => [
            ...value.persons,
            ...value.operations,
            ...value.payments,
            ...value.risks
        ]);

        return {
            1726: questionnaireProvider.find(qst => qst.idQuestion === 1726)?.idAnswerOption || '',
            1727: questionnaireProvider.find(qst => qst.idQuestion === 1727)?.answer || '',
            1728: questionnaireProvider.find(qst => qst.idQuestion === 1728)?.answer || '',
            borrowerPersonId: idPerson,
            borrowerLegalId: personLegalId
        };
    }

    function handleConfirmationRemovalBorrowerFromEconomicGroup(fnConfirming) {
        setModalConfirmation({
            show: true,
            text: 'Você deseja realmente desassociar esse tomador do grupo econômico?',
            textButtonConfirm: '',
            textButtonCancel: '',
            onConfirm: () => {
                fnConfirming && fnConfirming();
                handleModalCancel();
            },
            onCancel: () => handleModalCancel(),
        })
    }

    useEffect(() => {
        getQuoteQuestionnaire();
        cache.getMessage("RESTRICTION_CNPJ_INTERN", 'pt-br', "355", authContext.token).then(msg => setMessageInternal(msg)).catch(err => console.log("error", err));
        cache.getMessage("RESTRICTION_CNPJ_EXTERN", 'pt-br', "355", authContext.token).then(msg => setMessageExternal(msg)).catch(err => console.log("error", err));
    }, []);

    useEffect(() => {
        buildValidation();
    }, [questionnaire, partners, shareCapital, limits, modalities, CNAESecondary]);

    useEffect(() => {
        setHasPermission(!((operation?.idOperation && !permissions.EDIT_CREDIT_ANALYSIS) || (!operation?.idOperation && !permissions.CREATE_CREDIT_ANALYSIS)));
    }, [permissions, operation]);

    return (
        <Layout
            title={operation?.idOperation ? "Editar Análise de Crédito" : "Nova Análise de Crédito"}
            subtitle={`${product?.PRODUCT_NAME || ""}`}
            extraSubtitle={`${operation?.idOperation || ""}`}
        >
            <StepNavigation
                stage={1}
                idOperation={match?.params?.idOperation}
                permissions={permissions}
            />

            <BrokingSummary
                idProduct={match?.params?.idProduct}
                idOperation={match?.params?.idOperation}
                history={history}
                permissions={permissions}
            />

            <NotesModal
                title={'Informações Adicionais'}
                textButtonConfirm={'Confirmar'}
                textButtonCancel={'Cancelar'}
                show={notesModal}
                setModalShow={setNotesModal}
                customCancelButton={[Colors.WHITE, Colors.PRIMARY1]}
                idOperation={idOperation}
                idQuestion={1812}
                functionCallback={async () => {
                    await useResetOperationStateRequest({ idDomainOrigin: 26 });
                    const { status } = await useUpdateOperationRequest({ idDomainStatus: 4 });
                    if (status === 200) history.push('/credit-analysis');
                }}
            />

            <EconomicGroupStatement
                formik={formikRef}
                visible={!!modalEconomicGroup}
                modalEconomicGroup={modalEconomicGroup}
                setModalEconomicGroup={setModalEconomicGroup}
                economicGroup={economicGroup}
            />

            <ModalConfirmation
                show={modalConfirmation.show}
                showTitle={false}
                text={modalConfirmation.text}
                textButtonConfirm={modalConfirmation.textButtonConfirm || "Confirmar"}
                textButtonCancel={modalConfirmation.textButtonCancel || "Cancelar"}
                onConfirm={async () => modalConfirmation.onConfirm()}
                onCancel={() => modalConfirmation.onCancel()}
            />

            <Formik
                innerRef={formikRef}
                initialValues={{}}
                validateOnChange={false}
                validateOnBlur={false}
                enableReinitialize={true}
            >
                {({ values, setFieldValue, errors, setFieldError }) => (<>
                    <Form>
                        <GroupFormContainer isChild>
                            {(handleCollapse, collapseAll, collapseChild) => (<div>
                                <FormContainer
                                    enumerate={"1"}
                                    toggle={collapseAll}
                                    noTitlePadding
                                    title="Informações Cadastrais do tomador"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "BORROWER", questionnaire, permissions, currentModality, ignoreVisibilityByModality: true })}
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="BORROWER"
                                        disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                        showWarning={isAwaitingAnalysis}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreModality
                                        onBlur={(
                                            question,
                                            value
                                        ) => {
                                            if (![1634].includes(question.idQuestion) || value?.length < 11) return null
                                            setForceLoading(true);
                                        }}
                                        onRequestSerproCnpj={(
                                            question,
                                            data,
                                            setFieldValue,
                                            adHoc
                                        ) => {
                                            if (data.ni) {
                                                setTimeout(() => setForceLoading(true), 100)
                                                useCheckBorrowerHasCreditAnalysisRequest(null, {
                                                    idProduct: match.params.idProduct,
                                                    borrowerLegalId: data.ni,
                                                    idQuestion: 1634
                                                }).then(({ data: { value } }) => {
                                                    if (value?.creditAnalysisOperationWithBroker && !adHoc && (value.creditAnalysisOperationWithBroker.idOperation != idOperation)) {
                                                        setForceLoading(false);
                                                        mc.success(`Já existe uma análise de crédito para este tomador`);
                                                        history.push(
                                                            `/credit-analysis/edit/57/${value.creditAnalysisOperationWithBroker.idOperation}`
                                                        );
                                                        window.location.reload();
                                                        return
                                                    } else if (value?.creditAnalysisOperationsWithOtherBroker?.length && (value.creditAnalysisOperationsWithOtherBroker.every((operation) => operation.idOperation != idOperation))) {
                                                        setForceLoading(false);
                                                        mc.error('Já existe uma análise de crédito em andamento para este tomador solicitada por outro corretor, favor contate a unidade');
                                                        setFieldValue(question.key, '');
                                                    } else {
                                                        setForceLoading(true);
                                                        setTimeout(() => {
                                                            borrowerHandler.events.handleRequestSerproCnpj({
                                                                question,
                                                                data,
                                                                operation,
                                                                questionnaire,
                                                                setQuestionnaire,
                                                                setFieldValue,
                                                                partners,
                                                                setPartners,
                                                                CNAESecondary,
                                                                setCNAESecondary,
                                                                cnaeClassificationData,
                                                                limits,
                                                                modalitiesFeesData,
                                                                scoreInformationData,
                                                                modalities,
                                                                setModalities,
                                                                questionnaireAnswersToDelete,
                                                                setQuestionnaireAnswersToDelete,
                                                            });
                                                        }, 3000)
                                                        setTimeout(() => setForceLoading(false), 5000);
                                                    }
                                                })
                                            }
                                        }}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => borrowerHandler.events.handleQuestionChange({
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                        })}
                                        permissions={permissions}
                                    />
                                    <FormContainer
                                        noTitlePadding
                                        title='CNAE SECUNDARIO'
                                        enumerate={"2"}
                                        enumerateChildren={"1"}
                                        collapsedAtStart={true}
                                        toggle={collapseAll}
                                        toggleChild={collapseChild}
                                    >
                                        {generalHandler.events.sectionIsVisible({ sectionName: "BORROWER_SEC", questionnaire: (CNAESecondary && CNAESecondary[0]) || [], permissions, currentModality, ignoreVisibilityByModality: true }) &&
                                            CNAESecondary.map((questions, index) => (
                                                <FormSection
                                                    setQuestionnaire={(questionnaire) => setCNAESecondary(CNAESecondary.map((v, i) => i === index ? questionnaire : v))}
                                                    sectionName="BORROWER_SEC"
                                                    sectionIndex={index}
                                                    disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                                    showWarning={isAwaitingAnalysis}
                                                    idProduct={match.params.idProduct}
                                                    values={values}
                                                    errors={errors}
                                                    setFieldValue={setFieldValue}
                                                    setFieldError={setFieldError}
                                                    questionnaire={questions}
                                                    formikRef={formikRef}
                                                    permissions={permissions}
                                                />
                                            ))
                                        }
                                    </FormContainer>

                                    <FormContainer
                                        toggle={collapseAll}
                                        toggleChild={collapseChild}
                                        enumerate={"3"}
                                        enumerateChildren={"1"}
                                        noTitlePadding
                                        title="Quadro Societário Administrativo"
                                        hide={!generalHandler.events.sectionIsVisible({ sectionName: "PARTNER", questionnaire: partners && partners[0] || [], permissions, currentModality, ignoreVisibilityByModality: true })}
                                        collapsedAtStart={true}
                                    >
                                        {partners.map((questions, index) => (
                                            <FormContainer
                                                noTitlePadding
                                                title={questions.find(v => v.idQuestion === 1787)?.answer || 'Sócio'}
                                                collapsedAtStart={true}
                                                toggle={collapseAll}
                                                toggleChild={collapseChild}
                                                enumerate={index + 1}
                                                enumerateChildren={"1.3"}
                                            >
                                                <FormSection
                                                    setQuestionnaire={(questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v))}
                                                    sectionName="PARTNER"
                                                    sectionIndex={index}
                                                    disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                                    showWarning={isAwaitingAnalysis}
                                                    idProduct={match.params.idProduct}
                                                    values={values}
                                                    errors={errors}
                                                    setFieldValue={setFieldValue}
                                                    setFieldError={setFieldError}
                                                    formikRef={formikRef}
                                                    questionnaire={questions}
                                                    ignoreModality
                                                    onSearchZipCode={(zipCodeData, setFieldValue, rootQuestion) => partnerHandler.events.handleSearchZipCode({
                                                        rootQuestion,
                                                        zipCodeData,
                                                        questionnaire: questions,
                                                        setQuestionnaire: (questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v)),
                                                        setFieldValue
                                                    })}
                                                    extraButtons={() => generalHandler.components.renderSectionExtraButtons({
                                                        partySectionName: "$ANSWERS_PARTNERS_GROUP_0",
                                                        sectionState: partners,
                                                        setSectionState: setPartners,
                                                        index,
                                                        questions,
                                                        questionnaireAnswersToDelete,
                                                        setQuestionnaireAnswersToDelete,
                                                        setFieldValue,
                                                        ignoreRemove: false,
                                                        documentCCG,
                                                        operation
                                                    })}
                                                    onQuestionChange={(
                                                        question,
                                                        value,
                                                        setFieldValue,
                                                        questionnaireUpdated
                                                    ) => {
                                                        partnerHandler.events.handleQuestionChange({
                                                            question,
                                                            value,
                                                            questionnaireUpdated,
                                                            setQuestionnaire: (questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v)),
                                                            setFieldValue,
                                                        })
                                                    }}
                                                    onRequestSerproCnpj={(
                                                        question,
                                                        data,
                                                        setFieldValue
                                                    ) => partnerHandler.events.handleRequestSerproCnpj({
                                                        question,
                                                        data,
                                                        questionnaire: questions,
                                                        setQuestionnaire: (questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v)),
                                                        setFieldValue,
                                                    })}
                                                    extraButtonsQuestion={(question) => {
                                                        if (question.idQuestion !== 1661) return null
                                                        return (
                                                            <RefreshButon type="button" onClick={() => useGetSerasaStatusPartnerAsyncRequest({ cpfCnpj: questions.find((v) => v.idQuestion === 1654).answer }, { draft: true })
                                                                .then(({ data }) => {
                                                                    if (!data.ret_value) return;

                                                                    partnerHandler.events.handleQuestionChange({
                                                                        question,
                                                                        value: data?.ret_value,
                                                                        questionnaireUpdated: questions,
                                                                        setQuestionnaire: (questionnaire) => setPartners(partners.map((v, i) => i === index ? questionnaire : v)),
                                                                        setFieldValue,
                                                                    });
                                                                })}>
                                                                <Icon name='generate' title='Consultar Score Serasa' />
                                                            </RefreshButon>
                                                        )
                                                    }}
                                                    permissions={permissions}
                                                />
                                            </FormContainer>
                                        ))}
                                    </FormContainer>
                                </FormContainer>

                                <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"2"}
                                    noTitlePadding
                                    title="Composição Capital Social"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "SHARE_CAPITAL", questionnaire: shareCapital && shareCapital[0] || [], permissions, currentModality, ignoreVisibilityByModality: true })}
                                >
                                    {shareCapital.map((questions, index) => (
                                        <FormSection
                                            setQuestionnaire={(questionnaire) => setShareCapital(shareCapital.map((v, i) => i === index ? questionnaire : v))}
                                            sectionName="SHARE_CAPITAL"
                                            sectionIndex={index}
                                            disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                            showWarning={isAwaitingAnalysis}
                                            idProduct={match.params.idProduct}
                                            values={values}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            setFieldError={setFieldError}
                                            questionnaire={questions}
                                            formikRef={formikRef}
                                            extraButtons={() => {
                                                if ([416, 417, 418, 425].includes(operation?.idDomainStatus)) {
                                                    return generalHandler.components.renderSectionExtraButtons({
                                                        partySectionName: "$ANSWERS_SHARE_CAPITAL_0",
                                                        sectionState: shareCapital,
                                                        setSectionState: setShareCapital,
                                                        index,
                                                        questions,
                                                        questionnaireAnswersToDelete,
                                                        setQuestionnaireAnswersToDelete,
                                                        setFieldValue,
                                                        ignoreRemove: false,
                                                        onRemove: (newShareCapital, answerToDelete) => {
                                                            const isProjectQuestion = questionnaire.find(qst => qst.idQuestion === 1723);
                                                            const consumedLimitGroup = limits[limits.length - 1].find(qst => qst.idQuestion === 1832);

                                                            if (isProjectQuestion?.idAnswerOption === 7336 && consumedLimitGroup?.idAnswerOption === 7419) {
                                                                setTimeout(() => {
                                                                    limitsHandler.events.handleSPELimit({
                                                                        globalQuestionnaire: questionnaire,
                                                                        limits,
                                                                        setLimits,
                                                                        shareCapital: newShareCapital,
                                                                        setFieldValue: formikRef.current?.setFieldValue,
                                                                        modalitiesFeesData,
                                                                        scoreInformationData,
                                                                        modalities,
                                                                        setModalities,
                                                                        setQuestionnaireAnswersToDelete,
                                                                        questionnaireAnswersToDelete: answerToDelete,
                                                                        useGetBorrowersInformationByLegalPersonIdsRequest,
                                                                        mc,
                                                                    })
                                                                }, 1000)
                                                            }
                                                        },
                                                        documentCCG
                                                    })
                                                }
                                            }}
                                            onQuestionChange={(
                                                question,
                                                value,
                                                setFieldValue,
                                                questionnaireUpdated
                                            ) => {
                                                shareCapitalHandler.events.handleQuestionChange({
                                                    question,
                                                    value,
                                                    questionnaireUpdated,
                                                    setQuestionnaire: (questionnaire) => setShareCapital(shareCapital.map((v, i) => i === index ? questionnaire : v)),
                                                    setFieldValue,
                                                    token: authContext.token,
                                                    globalQuestionnaire: questionnaire,
                                                    updateIsLoadingStatus
                                                });
                                            }}
                                            onBlur={(
                                                question,
                                                value,
                                                setFieldValue,
                                                questionnaireUpdated
                                            ) => shareCapitalHandler.events.handleQuestionBlur({
                                                question,
                                                value,
                                                questionnaireUpdated,
                                                setQuestionnaire: (questionnaire) => setShareCapital(shareCapital.map((v, i) => i === index ? questionnaire : v)),
                                                setFieldValue,
                                                modalities,
                                                setModalities,
                                                modalitiesFeesData,
                                                limits,
                                                setLimits,
                                                shareCapital: shareCapital.map((v, i) => i === index ? questionnaireUpdated : v),
                                                scoreInformationData,
                                                globalQuestionnaire: questionnaire,
                                                questionnaireAnswersToDelete,
                                                setQuestionnaireAnswersToDelete,
                                                useGetBorrowersInformationByLegalPersonIdsRequest,
                                            })}
                                            onRequestSerproCnpj={(
                                                question,
                                                data,
                                                setFieldValue
                                            ) => shareCapitalHandler.events.handleRequestSerproCnpj({
                                                question,
                                                data,
                                                operation,
                                                questionnaire: questions,
                                                setQuestionnaire: (questionnaire) => setShareCapital(shareCapital.map((v, i) => i === index ? questionnaire : v)),
                                                setFieldValue,
                                                useGetShareCapitalInfoByLegalPersonIdRequest,
                                                globalQuestionnaire: questionnaire,
                                                limits,
                                                setLimits,
                                                shareCapital,
                                                modalitiesFeesData,
                                                scoreInformationData,
                                                modalities,
                                                setModalities,
                                                setQuestionnaireAnswersToDelete,
                                                questionnaireAnswersToDelete,
                                                useGetBorrowersInformationByLegalPersonIdsRequest,
                                            })}
                                            permissions={permissions}
                                        />
                                    ))}
                                </FormContainer>

                                <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"3"}
                                    noTitlePadding
                                    title="Informações para análise crédito"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "CREDIT_ANALYSIS_INFO", questionnaire, permissions, currentModality, ignoreVisibilityByModality: true })}
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="CREDIT_ANALYSIS_INFO"
                                        disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                        showWarning={isAwaitingAnalysis}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreModality
                                        onBlur={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => {
                                            if (![1670, 1671, 1672, 1673, 1674, 1675, 1676].includes(question.idQuestion)) return null
                                            setForceLoading(true);
                                            setTimeout(() => setForceLoading(false), 1000)
                                            creditAnalysisInfoHandler.events.handleQuestionBlur({
                                                question,
                                                value,
                                                questionnaireUpdated,
                                                setQuestionnaire,
                                                setFieldValue,
                                                limits,
                                                modalities,
                                                setModalities,
                                                modalitiesFeesData,
                                                scoreInformationData,
                                                questionnaireAnswersToDelete,
                                                setQuestionnaireAnswersToDelete,
                                                questionAnswersSERASA: null,
                                                globalQuestionnaire: questionnaire
                                            })
                                        }}
                                        extraButtonsQuestion={(question) => {
                                            return (
                                                <>
                                                    {warnings.includes(question.idQuestion) && (
                                                        <Icon name='exclamation-red' title='Não foi possível encontrar a informação' />
                                                    )}

                                                    {question.idQuestion === 1663 && (
                                                        <div>
                                                            <RefreshButon type="button" onClick={() => useGetPetCadinStatusAsyncRequest({ idOperation, operationType: "CADIN" }, { draft: true })
                                                                .then(({ data }) => {
                                                                    if (!data.ret_value) return;

                                                                    setForceLoading(true);
                                                                    setTimeout(() => setForceLoading(false), 3000)
                                                                    creditAnalysisInfoHandler.events.handleQuestionBlur({
                                                                        question: questionnaire.find(q => q.idQuestion === 1663),
                                                                        value: data?.ret_value,
                                                                        questionnaireUpdated: questionnaire,
                                                                        setQuestionnaire,
                                                                        setFieldValue,
                                                                        limits,
                                                                        modalities,
                                                                        setModalities,
                                                                        modalitiesFeesData,
                                                                        scoreInformationData,
                                                                        questionnaireAnswersToDelete,
                                                                        setQuestionnaireAnswersToDelete,
                                                                        questionAnswersSERASA: null,
                                                                        globalQuestionnaire: questionnaire
                                                                    })
                                                                    mc.success("Informações do CADIN atualizadas com sucesso!")
                                                                })
                                                                .catch(() => mc.error("Erro na requisição do sistema externo. Não foi possível consultar CADIN. Tente novamente."))}>
                                                                <Icon name='generate-small' title='Consultar CADIN' />
                                                            </RefreshButon>
                                                        </div>
                                                    )}

                                                    {question.idQuestion === 1666 && (
                                                        <div>
                                                            <RefreshButon type="button" onClick={(e) => {
                                                                if (isBound || !permissions.EDIT_CREDIT_ANALYSIS) return;

                                                                useGetDefaultingStatusAsyncRequest({ idOperation }, { draft: true })
                                                                    .then(({ data }) => {
                                                                        if (!data.ret_value) return;

                                                                        e.preventDefault();
                                                                        setForceLoading(true);
                                                                        setTimeout(() => setForceLoading(false), 3000)
                                                                        creditAnalysisInfoHandler.events.handleQuestionBlur({
                                                                            question: questionnaire.find(q => q.idQuestion === 1666),
                                                                            value: data?.ret_value,
                                                                            questionnaireUpdated: questionnaire,
                                                                            setQuestionnaire,
                                                                            setFieldValue,
                                                                            limits,
                                                                            modalities,
                                                                            setModalities,
                                                                            modalitiesFeesData,
                                                                            scoreInformationData,
                                                                            questionnaireAnswersToDelete,
                                                                            setQuestionnaireAnswersToDelete,
                                                                            questionAnswersSERASA: null,
                                                                            globalQuestionnaire: questionnaire,
                                                                            setOutOfRangeError
                                                                        })
                                                                        mc.success("Informações de inadimplência atualizadas com sucesso")
                                                                    })
                                                                    .catch(() => mc.error("Erro na requisição do sistema externo. Não foi possível consultar as informações de inadimplência. Tente novamente."))
                                                            }}>
                                                                <Icon name='generate-small' title='Consultar Inadimplência' />
                                                            </RefreshButon>
                                                        </div>
                                                    )}

                                                    {question.idQuestion === 1676 && (
                                                        <RefreshButon type="button" onClick={() => {
                                                            if (isBound || !permissions.EDIT_CREDIT_ANALYSIS) return;

                                                            useGetSerasaStatusAsyncRequest({ idOperation }, { draft: true })
                                                                .then(({ data }) => {
                                                                    if (!data.ret_value) return;

                                                                    const { responseRawDataObject: questionAnswersSERASA, integrationWarnings } = data.ret_value;

                                                                    setWarnings(integrationWarnings.map(warning => warning.question));
                                                                    setForceLoading(true);
                                                                    setTimeout(() => setForceLoading(false), 3000)
                                                                    creditAnalysisInfoHandler.events.handleQuestionBlur({
                                                                        question: questionnaire.find(q => q.idQuestion === 1676),
                                                                        value: questionAnswersSERASA["1676"],
                                                                        questionnaireUpdated: questionnaire,
                                                                        setQuestionnaire,
                                                                        setFieldValue,
                                                                        limits,
                                                                        modalities,
                                                                        setModalities,
                                                                        modalitiesFeesData,
                                                                        scoreInformationData,
                                                                        questionnaireAnswersToDelete,
                                                                        setQuestionnaireAnswersToDelete,
                                                                        questionAnswersSERASA,
                                                                        globalQuestionnaire: questionnaire,
                                                                        setOutOfRangeError
                                                                    })
                                                                    mc.success("Informações do Serasa atualizadas com sucesso!")
                                                                })
                                                                .catch(() => mc.error("Erro na requisição do sistema externo. Não foi possível consultar o SERASA. Tente novamente."))
                                                        }}>
                                                            <Icon name='generate' title='Consultar Score Serasa' />
                                                        </RefreshButon>
                                                    )}
                                                </>
                                            )
                                        }}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => creditAnalysisInfoHandler.events.handleQuestionChange({
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            limits,
                                            setLimits,
                                            setCanUpdateBorrowerSRO,
                                            economicGroup,
                                            mc,
                                            handleGetInfoCCGProvider
                                        }
                                        )}
                                        permissions={permissions}
                                        operation={operation}
                                    />
                                    <HasPermission permission={
                                        !isBound &&
                                        operation &&
                                        questionnaire.find(qst => qst.idQuestion === 1723)?.idAnswerOption === 7336 &&
                                        limits[limits.length - 1]?.find(qst => qst.idQuestion === 1832)?.idAnswerOption === 7419
                                    }>
                                        <ButtonContainer>
                                            <ButtonContent>
                                                <Button
                                                    type="button"
                                                    onClick={() => {
                                                        limitsHandler.events.handleSPELimit({
                                                            globalQuestionnaire: questionnaire,
                                                            limits,
                                                            setLimits,
                                                            shareCapital,
                                                            setFieldValue,
                                                            modalitiesFeesData,
                                                            scoreInformationData,
                                                            modalities,
                                                            setModalities,
                                                            setQuestionnaireAnswersToDelete,
                                                            questionnaireAnswersToDelete,
                                                            useGetBorrowersInformationByLegalPersonIdsRequest,
                                                            mc
                                                        });
                                                    }}
                                                    custom={[Colors.WHITE, Colors.TERTIARY]}
                                                >
                                                    RECALCULAR LIMITE APROVADO
                                                </Button>
                                            </ButtonContent>
                                        </ButtonContainer>
                                    </HasPermission>
                                </FormContainer>

                                <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"4"}
                                    noTitlePadding
                                    title="DADOS CCG"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "CCG_DATA", questionnaire, permissions, currentModality, ignoreVisibilityByModality: ![425].includes(operation?.idDomainStatus) })}
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        sectionName="CCG_DATA"
                                        disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                        showWarning={isAwaitingAnalysis}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreModality
                                        permissions={permissions}
                                        operation={operation}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => handleQuestionChange(
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            null,
                                            null,
                                            sharedCCG,
                                            operation,
                                            setPartners,
                                            null
                                        )}
                                    />
                                </FormContainer>

                                <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"5"}
                                    noTitlePadding
                                    title="Limites"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "LIMITS", questionnaire: limits && limits[0] || [], permissions, currentModality, ignoreVisibilityByModality: true })}
                                >
                                    {limits.map((questions, index) => (
                                        <FormSection
                                            setQuestionnaire={(questionnaire) => setLimits(limits.map((v, i) => i === index ? questionnaire : v))}
                                            sectionName="LIMITS"
                                            sectionIndex={index}
                                            disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                            showWarning={isAwaitingAnalysis}
                                            idProduct={match.params.idProduct}
                                            values={values}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            setFieldError={setFieldError}
                                            questionnaire={questions}
                                            ignoreModality
                                            formikRef={formikRef}
                                            extraButtons={() => {
                                                if ([416, 417, 418, 425].includes(operation?.idDomainStatus)) {
                                                    return generalHandler.components.renderSectionExtraButtons({
                                                        partySectionName: "LIMITS",
                                                        sectionState: limits,
                                                        setSectionState: setLimits,
                                                        index,
                                                        questions,
                                                        questionnaireAnswersToDelete,
                                                        setQuestionnaireAnswersToDelete,
                                                        setFieldValue,
                                                        ignoreRemove: true,
                                                        documentCCG
                                                    })
                                                }
                                            }}
                                            onQuestionChange={(
                                                question,
                                                value,
                                                setFieldValue,
                                                questionnaireUpdated
                                            ) => {
                                                limitsHandler.events.handleQuestionChange({
                                                    question,
                                                    value,
                                                    questionnaireUpdated,
                                                    setQuestionnaire: (questionnaire) => setLimits(limits.map((v, i) => i === index ? questionnaire : v)),
                                                    setFieldValue,
                                                    setCanUpdateBorrowerSRO,
                                                    globalQuestionnaire: questionnaire,
                                                    economicGroup,
                                                    token: authContext.token,
                                                    updateIsLoadingStatus,
                                                    shareCapital,
                                                    limits,
                                                    setLimits,
                                                    modalitiesFeesData,
                                                    scoreInformationData,
                                                    modalities,
                                                    setModalities,
                                                    questionnaireAnswersToDelete,
                                                    setQuestionnaireAnswersToDelete,
                                                    useGetBorrowersInformationByLegalPersonIdsRequest,
                                                    setOutOfRangeError
                                                })
                                            }}
                                            onBlur={(
                                                question,
                                                value,
                                                setFieldValue,
                                                questionnaireUpdated
                                            ) => {
                                                limitsHandler.events.handleQuestionBlurCCG(
                                                    question,
                                                    value,
                                                    questionnaireUpdated,
                                                    (questionnaire) => setLimits(limits.map((v, i) => i === index ? questionnaire : v)),
                                                    setFieldValue
                                                )

                                                if (![1680].includes(question.idQuestion)) return null
                                                setForceLoading(true);
                                                setTimeout(() => setForceLoading(false), 3000)
                                                limitsHandler.events.handleQuestionBlur({
                                                    question,
                                                    value,
                                                    questionnaireUpdated: questionnaire,
                                                    setQuestionnaire,
                                                    setFieldValue,
                                                    modalities,
                                                    setModalities,
                                                    modalitiesFeesData,
                                                    scoreInformationData,
                                                    questionnaireAnswersToDelete,
                                                    setQuestionnaireAnswersToDelete,
                                                    setOutOfRangeError
                                                })
                                            }}
                                            permissions={permissions}
                                        />
                                    ))}
                                </FormContainer>

                                <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"6"}
                                    noTitlePadding
                                    title="Modalidades"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "MODALITY", questionnaire: modalities && modalities[0] || [], permissions, currentModality, ignoreVisibilityByModality: true })}
                                >
                                    {modalities.length <= 1 || outOfRangeError ? (
                                        <div style={{ padding: "0 40px" }}>
                                            <Label>
                                                Não existe modalidades disponíveis para este Tomador.
                                            </Label>
                                            <Label>
                                                Motivos: Para que seja realizado o enquadramento, favor verificar os campos "Capital Social, Score
                                                Serasa, PEFIN, REFIN, Faturamento Presumido, Limite Aprovado (Max. R$ {maskHelper.formatCurrency(authContext, maxRangeToModalityFee)}).
                                            </Label>
                                        </div>
                                    ) : modalities.map((questions, index) => (<>
                                        {index > 0 && questions[0]?.mainGroup && <ModalityBottomSeparatorLine />}
                                        <ModalityRowContainer>
                                            <div style={{ width: '10%' }}>
                                                {questions[0]?.mainGroup && <ModalityRowTitle>{questions[0].answer}</ModalityRowTitle>}
                                            </div>
                                            <div style={{ width: '10%' }}>
                                                {questions[1] && !questions[1].hideModality && <ModalityRowTitle maxWidth="365px">{questions[1].answer}</ModalityRowTitle>}
                                            </div>
                                            <div style={{ paddingLeft: '15px', width: '80%' }}>
                                                <FormSection
                                                    setQuestionnaire={(questionnaire) => setModalities(modalities.map((v, i) => i === index ? questionnaire : v))}
                                                    sectionName="MODALITY"
                                                    sectionIndex={index}
                                                    disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                                    showWarning={isAwaitingAnalysis}
                                                    idProduct={match.params.idProduct}
                                                    values={values}
                                                    errors={errors}
                                                    setFieldValue={setFieldValue}
                                                    setFieldError={setFieldError}
                                                    questionnaire={questions}
                                                    formikRef={formikRef}
                                                    permissions={permissions}
                                                />
                                            </div>
                                        </ModalityRowContainer>
                                    </>))}
                                </FormContainer>

                                <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"7"}
                                    noTitlePadding
                                    title="Empresa Grupo Econômico"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "ECONOMIC_GROUP", questionnaire: economicGroup && economicGroup[0]?.economicGroupRelationships[0]?.questions || [], permissions, currentModality, ignoreVisibilityByModality: true })}
                                >
                                    {economicGroup.map((groups, sectionIndex) => groups.economicGroupRelationships.length >= 1 && (
                                        <>
                                            <FormContainer
                                                toggle={collapseAll}
                                                noTitlePadding
                                                hide={false}
                                                title={`Nível ${groups.hierarchyLevel} - ${groups.economicGroupRelationships[0]?.questions.find(qst => qst.idQuestion === 1837)?.answer}`}
                                            >
                                                {
                                                    groups?.economicGroupRelationships?.map((group, groupIndex) => (
                                                        <div style={{ opacity: (group.personRelationshipExpireDate || groups?.headRelationshipExpired) && 0.5 }}>
                                                            <FormSection
                                                                setQuestionnaire={(questionnaire, idOperation) => setEconomicGroup(economicGroup.map((g, i) => {
                                                                    if (i === sectionIndex) {
                                                                        return {
                                                                            ...g,
                                                                            economicGroupRelationships: g.economicGroupRelationships.map((relationship, j) => {
                                                                                if (j === groupIndex) {
                                                                                    return {
                                                                                        ...relationship,
                                                                                        idOperation,
                                                                                        questions: questionnaire
                                                                                    };
                                                                                }
                                                                                return relationship;
                                                                            })
                                                                        };
                                                                    }
                                                                    return g;
                                                                }))}
                                                                sectionName="ECONOMIC_GROUP"
                                                                sectionIndex={sectionIndex}
                                                                disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                                                showWarning={isAwaitingAnalysis}
                                                                idProduct={match.params.idProduct}
                                                                values={values}
                                                                errors={errors}
                                                                setFieldValue={setFieldValue}
                                                                setFieldError={setFieldError}
                                                                questionnaire={group.questions}
                                                                formikRef={formikRef}
                                                                extraLeftChildren={economicGroupHandler.components.renderSectionExtraLeftChildren({ type: group.type })}
                                                                extraButtons={() => economicGroupHandler.components.renderSectionExtraButtons({
                                                                    questionnaire,
                                                                    economicGroup,
                                                                    setEconomicGroup,
                                                                    sectionIndex,
                                                                    groupIndex,
                                                                    economicGroupToDelete,
                                                                    setEconomicGroupToDelete,
                                                                    idOperation: group.idOperation,
                                                                    matchParamsIdOperation: match.params.idOperation,
                                                                    history,
                                                                    modalEconomicGroup,
                                                                    setModalEconomicGroup,
                                                                    referenceDate: systemReferenceDate,
                                                                    setDialog,
                                                                    handleConfirmationRemovalBorrowerFromEconomicGroup,
                                                                    operation

                                                                })
                                                                }
                                                                onQuestionChange={(
                                                                    question,
                                                                    value,
                                                                    setFieldValue,
                                                                    questionnaireUpdated
                                                                ) => economicGroupHandler.events.handleQuestionChange({
                                                                    question,
                                                                    value,
                                                                    questionnaireUpdated,
                                                                    setQuestionnaire: (questionnaire, idOperation) => setEconomicGroup(economicGroup.map((g, i) => {
                                                                        if (i === sectionIndex) {
                                                                            return {
                                                                                ...g,
                                                                                economicGroupRelationships: g.economicGroupRelationships.map((relationship, j) => {
                                                                                    if (j === groupIndex) {
                                                                                        return {
                                                                                            ...relationship,
                                                                                            idOperation,
                                                                                            questions: questionnaire
                                                                                        };
                                                                                    }
                                                                                    return relationship;
                                                                                })
                                                                            };
                                                                        }
                                                                        return g;
                                                                    })),
                                                                    setFieldValue,
                                                                    token: authContext.token,
                                                                    globalQuestionnaire: questionnaire,
                                                                    updateIsLoadingStatus,
                                                                    handleCurrentExposure,
                                                                    handleChoiceOfConsumptionLimit,
                                                                    borrowerConsumption,
                                                                    mc
                                                                })}
                                                                permissions={permissions}
                                                                brokerIdSelected={brokerIdSelected}
                                                                isEconomicGroup={questionnaire.find((questionnaireAnswer) => questionnaireAnswer.idQuestion === 1830)?.idAnswerOption === 7415}
                                                                debounceSearchRequest
                                                                searchRequestDebounceMS={1000}
                                                            />
                                                        </div>
                                                    ))
                                                }
                                            </FormContainer>
                                        </>
                                    ))}

                                    {economicGroupHandler.components.renderSectionTotals({
                                        questionnaire,
                                        economicGroup,
                                        setEconomicGroup,
                                        referenceDate: systemReferenceDate,
                                        matchParamsIdOperation: +match.params.idOperation,
                                        operation,
                                        economicGroupTotals: economicGroupTotals.current
                                    })}
                                </FormContainer>

                                <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"8"}
                                    noTitlePadding
                                    title="Informações do Parecer de Crédito"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "CREDIT_OPINION", questionnaire, permissions, currentModality, ignoreVisibilityByModality: true })}
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                        showWarning={isAwaitingAnalysis}
                                        sectionName="CREDIT_OPINION"
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreModality
                                        formikRef={formikRef}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => creditOpinionHandler.events.handleQuestionChange({
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                            token: authContext.token,
                                            globalQuestionnaire: questionnaire,
                                            updateIsLoadingStatus,
                                        })}
                                        permissions={permissions}
                                    />
                                </FormContainer>

                                {generalHandler.events.sectionIsVisible({ sectionName: "ATTACHMENTS", questionnaire, permissions, currentModality, ignoreVisibilityByModality: true }) && <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"9"}
                                    noTitlePadding
                                    title="Anexos"
                                    infoContent={infoRequiredDocs ?? ''}
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        disableAll={isBound || isAwaitingAnalysis || !hasPermission || ![416, 417, 418, 425].includes(operation?.idDomainStatus)}
                                        showWarning={isAwaitingAnalysis}
                                        sectionName={'ATTACHMENTS'}
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreTypeOfApplication
                                        periodicityOptions={[4632, 4633]}
                                        periodicityText={periodicityText}
                                        customTagListBg={Colors.PRIMARY1}
                                        permissions={permissions}
                                    />
                                </FormContainer>}

                                <FormContainer
                                    toggle={collapseAll}
                                    enumerate={"9"}
                                    noTitlePadding
                                    title="MEIO DE PAGAMENTO"
                                    hide={!generalHandler.events.sectionIsVisible({ sectionName: "PAYMENT_METHOD", questionnaire, permissions, currentModality, ignoreVisibilityByModality: true })}
                                >
                                    <FormSection
                                        setQuestionnaire={setQuestionnaire}
                                        disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                                        showWarning={isAwaitingAnalysis}
                                        sectionName="PAYMENT_METHOD"
                                        idProduct={match.params.idProduct}
                                        values={values}
                                        errors={errors}
                                        setFieldValue={setFieldValue}
                                        setFieldError={setFieldError}
                                        questionnaire={questionnaire}
                                        ignoreModality
                                        formikRef={formikRef}
                                        onQuestionChange={(
                                            question,
                                            value,
                                            setFieldValue,
                                            questionnaireUpdated
                                        ) => paymentMethodHandler.events.handleQuestionChange({
                                            question,
                                            value,
                                            questionnaireUpdated,
                                            setQuestionnaire,
                                            setFieldValue,
                                        }
                                        )}
                                        permissions={permissions}
                                    />
                                </FormContainer>

                            </div>)}
                        </GroupFormContainer>

                        <FormSection
                            sectionName="FINALIZE_CREDIT_ANALYSIS"
                            questionnaire={questionnaire}
                            setQuestionnaire={setQuestionnaire}
                            disableAll={isBound || isAwaitingAnalysis || !hasPermission}
                            values={values}
                            errors={errors}
                            setFieldValue={setFieldValue}
                            setFieldError={setFieldError}
                            ignoreModality
                            idProduct={match.params.idProduct}
                            permissions={permissions}
                        />

                        <ButtonContainer>
                            <Button forth onClick={() => handleBack()}> &lt; VOLTAR PARA LISTA</Button>
                            <HasPermission permission={true}>
                                <ButtonContent>
                                    <HasPermission permission={operation?.idDomainStatus && operation?.idDomainStatus !== 425 && operation?.idDomainStatus !== 418 && operation?.idDomainStatus !== 416 && permissions.REANALYZE_CREDIT_ANALYSIS}>
                                        <ButtonContent>
                                            <Button
                                                id="btnSave"
                                                type="button"
                                                onClick={() => setModalConfirmation({
                                                    show: true,
                                                    text: "Deseja realmente reanalisar este solicitação de análise de crédito?",
                                                    textButtonConfirm: '',
                                                    textButtonCancel: '',
                                                    onConfirm: () => handleReanalyze(),
                                                    onCancel: () => handleModalCancel()
                                                })}
                                                disabled={disableButton(operation)}
                                                custom={[Colors.WHITE, Colors.TERTIARY]}
                                            >
                                                REANALISAR
                                            </Button>
                                        </ButtonContent>
                                    </HasPermission>
                                    <HasPermission permission={operation?.idOperation && operation?.idDomainStatus !== 419 && permissions.REJECT_CREDIT_ANALYSIS}>
                                        <LostCancelButton title="RECUSAR" idQuestion={1725} idOperation={match?.params?.idOperation} />
                                    </HasPermission>
                                    <HasPermission permission={!isBound && permissions.EDIT_CREDIT_ANALYSIS}>
                                        <Button
                                            id="btnSave"
                                            type="button"
                                            onClick={async () => {
                                                setIsSaveAction(true);
                                                await onSave(values, null, (!operation?.idOperation || operation?.idDomainStatus === 425), false, setFieldError);
                                            }}
                                            disabled={disableButton(operation)}
                                            primary
                                        >
                                            SALVAR
                                        </Button>
                                    </HasPermission>

                                    <HasPermission permission={!isBound && (!operation?.idOperation || operation?.idDomainStatus === 425) && permissions.CREATE_CREDIT_ANALYSIS}>
                                        <Button
                                            id="btnSave"
                                            type="button"
                                            onClick={async () => await onSave(values, 416, false, false, setFieldError)}
                                            disabled={disableButton(operation)}
                                            custom={[Colors.WHITE, Colors.TERTIARY]}
                                        >
                                            CONTINUAR
                                        </Button>
                                    </HasPermission>
                                    <HasPermission
                                        permission={
                                            !isBound &&
                                            operation?.idOperation &&
                                            operation?.idDomainStatus == 439 &&
                                            permissions.GENERATE_CREDIT_ANALYSIS
                                        }
                                    >
                                        <Button
                                            id="btnSave"
                                            type="button"
                                            onClick={() => {
                                                onSave(values, null, undefined, true, setFieldError);
                                            }}
                                            disabled={disableButton(operation)}
                                            custom={[Colors.WHITE, Colors.TERTIARY]}>
                                            GERAR CCG
                                        </Button>
                                    </HasPermission>
                                    <HasPermission permission={!isBound && permissions.CREATE_ENQUIRY && operation?.operationMetadata?.envelopeExternalId}>
                                        <Button
                                            id="btnCreateQuote"
                                            type="button"
                                            onClick={() => history.push("/list")}
                                            style={{ marginLeft: 15 }}
                                            primary
                                        >
                                            CRIAR COTAÇÃO
                                        </Button>
                                    </HasPermission>
                                </ButtonContent>
                            </HasPermission>
                        </ButtonContainer>
                    </Form>
                    <DialogComponent
                        show={dialog.show}
                        title={dialog.title}
                        width={'580px'}
                    >
                        <FormSection
                            setQuestionnaire={() => { }}
                            sectionName="ECONOMIC_GROUP"
                            disableAll={true}
                            idProduct={match.params.idProduct}
                            values={values}
                            errors={errors}
                            setFieldValue={setFieldValue}
                            setFieldError={setFieldError}
                            questionnaire={dialog.questions}
                            formikRef={formikRef}
                            permissions={permissions}
                        />
                        <ButtonContent>
                            <Button
                                third
                                onClick={() => setDialog({ show: false, title: '', questions: [] })}
                            >
                                Fechar
                            </Button>
                        </ButtonContent>
                    </DialogComponent>
                </>)}
            </Formik>
        </Layout >
    )
}